import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Grid, IconButton, MenuItem, TextField, Typography, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Tooltip, Chip, Alert, CircularProgress, FormControlLabel, Checkbox
} from '@mui/material';
import {
  Add, Delete, Edit, Refresh, LocalShipping, Search,
  CheckCircle, Cancel, Warning, ExpandMore, ExpandLess, AttachFile,
  CloudUpload, Description, Archive
} from '@mui/icons-material';
import { GridOn } from '@mui/icons-material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import WhatsAppDialog from '../components/WhatsAppDialog';
import EmailDialog from '../components/EmailDialog';
import EmailIcon from '@mui/icons-material/Email';
import { fmtFecha } from '../utils/fmtFecha';
import { saveAs } from 'file-saver';
import { exportGuiasWorkbook, GUIA_CONFIG } from '../utils/excel/guiaWorkbook';
import { esTransportePublico as isPublicTransport, motivoRequiereDescripcion, validateGuiaForm } from '../utils/guiaValidation';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import ClienteRapidoDialog from '../components/ClienteRapidoDialog';
import ProductoRapidoDialog from '../components/ProductoRapidoDialog';
import ProductoBuscadorDialog, { StockAlmacenesDialog } from '../components/ProductoBuscadorDialog';
import { consultaDni } from '../utils/consultaPeru';
import debounce from 'lodash.debounce';

// ── Estado inicial detalle ────────────────────────────────────────────────
const initialDetalle = {
  producto_id: '',
  descripcion_producto: '',
  cantidad: 1,
  unidad_medida_id: '',
  unidad_medida: 'NIU',
  almacen_id: '',
  observaciones: ''
};

const ESTADO_CHIPS = {
  PENDIENTE:  { label: '⏳ Pendiente',       color: 'default' },
  ENVIADO:    { label: '📤 Enviado a SUNAT', color: 'warning' },
  ACEPTADO:   { label: '✅ Aceptado',        color: 'success' },
  RECHAZADO:  { label: '✗ Rechazado',        color: 'error' },
  ANULADO:    { label: '✗ Anulado',          color: 'default' },
};

const GUIA_PDF_FORMATOS = [
  { value: 'A4', label: 'A4' },
  { value: 'A5', label: 'A5' },
  { value: 'T80', label: 'T80 (ticket)' }
];

const today = () => new Date().toLocaleDateString('en-CA');

// ── Componente ────────────────────────────────────────────────────────────
const GuiaRemisionTransportistaPage = () => {
  // ── Catalogos ─────────────────────────────────────────────────────────
  const [tiposGuia,        setTiposGuia]        = useState([]);
  const [motivosTraslado,  setMotivosTraslado]  = useState([]);
  const [vehiculos,        setVehiculos]        = useState([]);
  const [choferes,         setChoferes]         = useState([]);
  const [transportistas,   setTransportistas]   = useState([]);
  const [unidades,         setUnidades]         = useState([]);
  const [almacenes,        setAlmacenes]        = useState([]);
  const [productosCatalogo, setProductosCatalogo] = useState([]);
  const [sucursales,       setSucursales]       = useState([]);
  const [loadingSucursales, setLoadingSucursales] = useState(false);
  const [vendedores,       setVendedores]       = useState([]);
  const [monedas,          setMonedas]          = useState([]);
  const [monedaInput,      setMonedaInput]      = useState('');
  const [loadingMonedas,   setLoadingMonedas]   = useState(false);
  const [clientes,         setClientes]         = useState([]);
  const [clienteInput,     setClienteInput]     = useState('');
  const [openNuevoCliente, setOpenNuevoCliente] = useState(false);
  const [openNuevoProducto, setOpenNuevoProducto] = useState(false);
  const [productoInput,    setProductoInput]    = useState('');
  const [seriesDisponibles, setSeriesDisponibles] = useState([]);
  const [serieInput,       setSerieInput]       = useState('');
  const [loadingSeries,    setLoadingSeries]    = useState(false);

  // ── Lista principal ────────────────────────────────────────────────────
  const [guias,            setGuias]            = useState([]);
  const [loadingGuias,     setLoadingGuias]     = useState(false);
  const [isRefreshingList, setIsRefreshingList] = useState(false);
  const [reenviandoGuiaId, setReenviandoGuiaId] = useState(null);
  const [filtroTipo]                          = useState('31');
  const [busqueda,         setBusqueda]         = useState('');
  const [openPdfDialog,    setOpenPdfDialog]    = useState(false);
  const [guiaPdfTarget,    setGuiaPdfTarget]    = useState(null);
  const [wspDialog,        setWspDialog]        = useState({ open: false, data: null });
  const [emailDialog,      setEmailDialog]      = useState({ open: false, data: null });
  const [anularDialog,     setAnularDialog]     = useState({ open: false, data: null, confirmado: false });
  const [anulandoGuiaId,   setAnulandoGuiaId]   = useState(null);
  const [openStockAlmacen, setOpenStockAlmacen] = useState(false);
  const [pdfFormatoSeleccionado, setPdfFormatoSeleccionado] = useState(() => localStorage.getItem('guia_pdf_formato_default') || 'A4');
  const [pageGuias,        setPageGuias]        = useState(0);
  const [rowsPerPageGuias, setRowsPerPageGuias] = useState(8);

  // ── Formulario principal ───────────────────────────────────────────────
  const [openForm,        setOpenForm]          = useState(false);
  const [modoEdicion,     setModoEdicion]       = useState(false);
  const [saving,          setSaving]            = useState(false);
  const [formError,       setFormError]         = useState('');

  const [form, setForm] = useState({
    id: null,
    tipo_guia: '31',
    sucursal_id: '',
    vendedor_id: '',
    serie: '',
    numero: '',
    fecha_emision: today(),
    moneda: 'PEN',
    tipo_cambio: 1,
    motivo_traslado: '01',
    descripcion_motivo: '',
    peso_bruto_total: '',
    bultos: 1,
    unidad_medida_peso: 'KGM',
    fecha_inicio_traslado: today(),
    // Partida / Llegada
    punto_partida_almacen_id: '',
    punto_partida_ubigeo: '',
    punto_partida_direccion: '',
    punto_llegada_almacen_id: '',
    punto_llegada_ubigeo: '',
    punto_llegada_direccion: '',
    // Destinatario
    cliente_id: '',
    destinatario_tipo_doc: '6',
    destinatario_numero_doc: '',
    destinatario_razon_social: '',
    // Transporte
    tipo_transporte: 'Publico',
    transportista_ruc: '',
    transportista_razon_social: '',
    transportista_registro_mtc: '',
    // Vehículo y chofer
    vehiculo_placa: '',
    chofer_tipo_doc: '1',
    chofer_numero_doc: '',
    chofer_nombres: '',
    chofer_licencia: '',
    vehiculo_secundario_placa: '',
    transbordo_programado: false,
    pagador_flete: 'remitente',
    tercero_tipo_doc: '6',
    tercero_numero_doc: '',
    tercero_razon_social: '',
    // Opciones
    retorno_vehiculo_vacio: false,
    retorno_envases_vacios: false,
    // Remitente (tipo 31 - quien encarga el traslado)
    remitente_tipo_doc: '6',
    remitente_numero_doc: '',
    remitente_razon_social: '',
    observaciones: '',
    dato_adicional_placa: '',
    // Comprobante relacionado
    comprobante_relacionado_id: '',
    comprobante_relacionado_ref: '',
    // Adjuntos (UI)
    adjuntos: [],
  });
  const [detalles, setDetalles] = useState([]);
  const [adjuntos, setAdjuntos] = useState([]);

  const [sucursalInput, setSucursalInput] = useState('');

  // ── Detalle dialog ────────────────────────────────────────────────────
  const [detalleForm,     setDetalleForm]       = useState({ ...initialDetalle });
  const [detalleIdx,      setDetalleIdx]        = useState(null);
  const [openBuscadorProducto, setOpenBuscadorProducto] = useState(false);
  const [copiarNombreADesc, setCopiarNombreADesc] = useState(true);

  // ── Búsqueda destinatario ─────────────────────────────────────────────
  const [busqDestinatario,  setBusqDestinatario]  = useState('');
  const [optDestinatario,   setOptDestinatario]   = useState([]);
  const [loadingDestinatario, setLoadingDestinatario] = useState(false);

  // ── Comprobante referencia ────────────────────────────────────────────
  const [openCompRefDialog, setOpenCompRefDialog] = useState(false);
  const [loadingImportRef, setLoadingImportRef] = useState(false);
  const [referenciasComp, setReferenciasComp] = useState([]);
  const [searchReferenciaComp, setSearchReferenciaComp] = useState('');
  const [tipoDocReferenciaComp, setTipoDocReferenciaComp] = useState('01');
  const [loadingReferenciasComp, setLoadingReferenciasComp] = useState(false);

  // ── Sección transporte expandida ──────────────────────────────────────
  const [expandTransporte, setExpandTransporte]  = useState(true);
  const [expandPartidaLlegada, setExpandPartidaLlegada] = useState(true);
  const [expandComprobanteRelacionado, setExpandComprobanteRelacionado] = useState(true);
  const [openDatosAdicionales, setOpenDatosAdicionales] = useState(false);
  const [placaAdicional, setPlacaAdicional] = useState('');

  // ── CRUD auxiliares (vehículo, chofer, transportista) ─────────────────
  const [openVehiculo,    setOpenVehiculo]      = useState(false);
  const [openChofer,      setOpenChofer]        = useState(false);
  const [openTransportista, setOpenTransportista] = useState(false);
  const [vehiculoForm,    setVehiculoForm]      = useState({ placa:'', marca:'', modelo:'', color:'', nro_certificado_inscripcion:'' });
  const [choferForm,      setChoferForm]        = useState({ nombres:'', apellidos:'', tipo_documento:'1', numero_documento:'', licencia:'' });
  const [loadingChoferDni, setLoadingChoferDni] = useState(false);
  const [choferDniError,   setChoferDniError]   = useState('');
  const [transportistaForm, setTransportistaForm] = useState({ ruc:'', razon_social:'', tipo_transporte:'Publico', numero_registro_mtc:'', direccion:'' });
  const [openPuntosPartida, setOpenPuntosPartida] = useState(false);
  const [puntoForm, setPuntoForm] = useState({ id: null, nombre: '', descripcion: '', sucursal_id: '', direccion: '', ubigeo: '', estado: 1 });
  const [ubigeoOptions, setUbigeoOptions] = useState([]);
  const [ubigeoInputPunto, setUbigeoInputPunto] = useState('');
  const [loadingUbigeoPunto, setLoadingUbigeoPunto] = useState(false);

  // ── Direcciones por cliente ───────────────────────────────────────────────
  const [direccionesCliente, setDireccionesCliente] = useState([]);
  const [openDirecciones, setOpenDirecciones] = useState(false);
  const [dirForm, setDirForm] = useState({ id: null, descripcion: 'Principal', direccion: '', ubigeo: '', ubigeo_desc: '', es_principal: false });
  const [dirError, setDirError] = useState('');
  const [ubigeosDirDlg, setUbigeosDirDlg] = useState([]);
  const [ubigeoInputDirDlg, setUbigeoInputDirDlg] = useState('');
  const [ubigeoSelDirDlg, setUbigeoSelDirDlg] = useState(null);
  const [llegadaWasEdited, setLlegadaWasEdited] = useState(false);

  let usuarioLogueado = null;
  try { usuarioLogueado = JSON.parse(localStorage.getItem('usuario') || 'null'); } catch { usuarioLogueado = null; }
  const usuario = usuarioLogueado?.username || usuarioLogueado?.usuario || localStorage.getItem('usuario') || 'sistema';
  const usuarioId = usuarioLogueado?.id || '';

  // ── Cargar catálogos al montar ─────────────────────────────────────────
  useEffect(() => {
    cargarCatalogos();
    cargarGuias();
  }, []);

  const cargarCatalogos = async () => {
    try {
      setLoadingSucursales(true);
      const [rTipos, rMotivos, rVeh, rCho, rTrans, rUnd, rAlm, rProd, rSuc, rUsers, rMon, rClientes] = await Promise.allSettled([
        axios.get('/api/guia-remision/catalogo/tipos-guia'),
        axios.get('/api/guia-remision/catalogo/motivos-traslado'),
        axios.get('/api/guia-remision/catalogo/vehiculos'),
        axios.get('/api/guia-remision/catalogo/choferes'),
        axios.get('/api/guia-remision/catalogo/transportistas'),
        axios.get('/api/unidades'),
        axios.get('/api/almacen/mis-almacenes'),
        axios.get('/api/productos'),
        axios.get('/api/sucursales/mis-sucursales'),
        axios.get('/api/usuarios'),
        axios.get('/api/monedas'),
        axios.get('/api/auxiliares'),
      ]);

      const ok = (r) => r.status === 'fulfilled' ? (r.value.data || []) : [];
      setTiposGuia(ok(rTipos));
      setMotivosTraslado(ok(rMotivos));
      setVehiculos(ok(rVeh));
      setChoferes(ok(rCho));
      setTransportistas(ok(rTrans));
      setUnidades(ok(rUnd));
      setAlmacenes(ok(rAlm));
      setProductosCatalogo(ok(rProd));
      const sucursalesData = ok(rSuc);
      setSucursales(sucursalesData);
      const usuariosData = ok(rUsers);
      setVendedores(usuariosData);
      setMonedas(ok(rMon));
      setClientes(ok(rClientes));
      
      // Autoseleccionar primera sucursal y usuario logueado como vendedor
      if (sucursalesData.length > 0 && !modoEdicion) {
        setForm(f => ({ ...f, sucursal_id: sucursalesData[0].id }));
      }
      if (usuarioId && !modoEdicion) {
        setForm(f => ({ ...f, vendedor_id: usuarioId }));
      }
      setLoadingSucursales(false);
    } catch (err) {
      console.error('Error cargando catálogos GR:', err);
      setLoadingSucursales(false);
    }
  };

  const cargarSeriesPorSucursalUsuario = async (sucursalId, usuarioSerieId, tipoDoc) => {
    if (!sucursalId || !usuarioSerieId) { setSeriesDisponibles([]); return; }
    try {
      const [resSeries, resPermisos] = await Promise.all([
        axios.get(`/api/series/sucursal/${sucursalId}`),
        axios.get(`/api/usuario-serie/${usuarioSerieId}`),
      ]);
      const permitidas = (resSeries.data || []).filter(s =>
        String(s.tipo_documento || '') === String(tipoDoc || form.tipo_guia) &&
        (resPermisos.data || []).some(p => Number(p.id) === Number(s.id))
      );
      setSeriesDisponibles(permitidas);
      if (!modoEdicion) {
        const primera = permitidas[0];
        setForm(f => ({ ...f, serie: primera?.serie || '' }));
      }
    } catch (err) {
      console.error('Error cargando series por sucursal/usuario:', err);
      setSeriesDisponibles([]);
    }
  };

  const cargarSiguienteNumero = async (tipoGuia, serie) => {
    if (!tipoGuia || !serie || modoEdicion) return;
    try {
      const resp = await axios.get('/api/guia-remision/siguiente-numero', { params: { tipo_guia: tipoGuia, serie } });
      setForm(f => ({ ...f, numero: resp.data?.siguiente || 1 }));
    } catch {
      setForm(f => ({ ...f, numero: '' }));
    }
  };

  // Cargar series automáticamente cuando se abre el formulario y tenemos sucursal + usuario
  useEffect(() => {
    if (!openForm || modoEdicion || !form.sucursal_id || !usuarioId) return;
    cargarSeriesPorSucursalUsuario(form.sucursal_id, usuarioId, form.tipo_guia);
  }, [form.sucursal_id, form.tipo_guia, openForm, modoEdicion, usuarioId]);

  // Cargar series inmediatamente cuando se abre el formulario
  useEffect(() => {
    if (openForm && !modoEdicion && form.sucursal_id && usuarioId) {
      cargarSeriesPorSucursalUsuario(form.sucursal_id, usuarioId, form.tipo_guia);
    }
  }, [openForm]);

  useEffect(() => {
    cargarSiguienteNumero(form.tipo_guia, form.serie);
  }, [form.tipo_guia, form.serie, modoEdicion]);

  const cargarGuias = async () => {
    setIsRefreshingList(true);
    setLoadingGuias(true);
    try {
      const params = {};
      params.tipo_guia = '31';
      if (busqueda)   params.search    = busqueda;
      const resp = await axios.get('/api/guia-remision', { params });
      setGuias(resp.data || []);
      setPageGuias(0);
    } catch (err) {
      console.error('Error cargando guías:', err);
    } finally {
      setLoadingGuias(false);
      setIsRefreshingList(false);
    }
  };

  useEffect(() => { cargarGuias(); }, [filtroTipo]);

  // ── Búsqueda destinatario (auxiliar) con debounce ─────────────────────
  const buscarDestinatario = useCallback(
    debounce(async (q) => {
      if (!q || q.length < 3) { setOptDestinatario([]); return; }
      setLoadingDestinatario(true);
      try {
        const resp = await axios.get('/api/auxiliares', { params: { search: q } });
        setOptDestinatario(resp.data || []);
      } catch { setOptDestinatario([]); }
      finally { setLoadingDestinatario(false); }
    }, 400),
    []
  );

  const fetchReferenciasComprobante = async () => {
    try {
      setLoadingReferenciasComp(true);
      const params = {};
      if (searchReferenciaComp && searchReferenciaComp.trim()) params.search = searchReferenciaComp.trim();
      if (tipoDocReferenciaComp) params.tipo_comprobante = tipoDocReferenciaComp;
      const res = await axios.get('/api/comprobante', { params });
      const filas = (res.data || []).filter(r => (r.estado_registro === 1 || r.estado_registro === true));
      setReferenciasComp(filas);
    } catch {
      setReferenciasComp([]);
    } finally {
      setLoadingReferenciasComp(false);
    }
  };

  useEffect(() => {
    if (openCompRefDialog) fetchReferenciasComprobante();
  }, [openCompRefDialog, tipoDocReferenciaComp, searchReferenciaComp]);

  const buscarUbigeoPunto = useCallback(
    debounce(async (q) => {
      if (!q || q.trim().length < 2) { setUbigeoOptions([]); return; }
      setLoadingUbigeoPunto(true);
      try {
        const res = await axios.get('/api/ubigeo', { params: { q: q.trim() } });
        setUbigeoOptions(Array.isArray(res.data) ? res.data : []);
      } catch {
        setUbigeoOptions([]);
      } finally {
        setLoadingUbigeoPunto(false);
      }
    }, 350),
    []
  );

  const mapDetalleComprobanteAGuia = (det) => ({
    producto_id: det?.producto_id || det?.id_producto || '',
    descripcion_producto: det?.descripcion_producto || det?.descripcion || det?.nombre_producto || '',
    cantidad: Number(det?.cantidad || det?.cantidad_total || 1) || 1,
    unidad_medida_id: det?.unidad_medida_id || det?.unidad_id || '',
    unidad_medida: det?.unidad_medida || det?.unidad || det?.codigo_unidad || 'NIU',
    almacen_id: det?.almacen_id || '',
    observaciones: det?.observaciones || ''
  });

  const aplicarComprobanteReferencia = async (compRef) => {
    if (!compRef || typeof compRef !== 'object') return;
    try {
      setLoadingImportRef(true);
      setFormError('');

      const refTexto = `${compRef.serie}-${String(compRef.numero).padStart(8,'0')}`;
      const compResp = await axios.get(`/api/comprobante/${compRef.id}`);
      const compData = compResp.data || {};
      const detallesRef = Array.isArray(compData.detalles)
        ? compData.detalles
            .map(mapDetalleComprobanteAGuia)
            .map(d => {
              const prod = productosCatalogo.find(p => Number(p.id) === Number(d.producto_id));
              return {
                ...d,
                descripcion_producto: d.descripcion_producto || prod?.nombre || prod?.descripcion || `Producto ${d.producto_id || ''}`.trim(),
                unidad_medida_id: d.unidad_medida_id || prod?.unidad_medida_id || '',
                unidad_medida: d.unidad_medida || prod?.unidad_medida || 'NIU',
                almacen_id: d.almacen_id || form.punto_partida_almacen_id || ''
              };
            })
        : [];

      setDetalles(detallesRef);

      setForm(f => ({
        ...f,
        comprobante_relacionado_id: compRef.id,
        comprobante_relacionado_ref: refTexto,
        destinatario_numero_doc: f.destinatario_numero_doc || compRef.cliente_ruc || '',
        destinatario_razon_social: f.destinatario_razon_social || compRef.cliente || '',
        observaciones: (f.observaciones || '').trim()
          ? f.observaciones
          : (compData.observaciones || '')
      }));

      if (!detallesRef.length) {
        setFormError('La referencia fue seleccionada, pero ese comprobante no tiene ítems para importar.');
      }

      setOpenCompRefDialog(false);
    } catch (err) {
      console.error('Error cargando comprobante referencia:', err);
      setFormError('No se pudo cargar el comprobante de referencia. Verifica e intenta nuevamente.');
    } finally {
      setLoadingImportRef(false);
    }
  };

  // ── Helpers formulario ────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => {
      const nextValue = type === 'checkbox' ? checked : value;
      if (name === 'tipo_guia') {
        return {
          ...f,
          tipo_guia: nextValue,
          // En la guía transportista (31), la modalidad es pública por defecto.
          tipo_transporte: nextValue === '31' ? 'Publico' : f.tipo_transporte || 'Privado',
        };
      }
      return { ...f, [name]: nextValue };
    });
  };

  const resetForm = () => {
    const primeraSuccursal = sucursales.length > 0 ? sucursales[0].id : '';
    setForm({
      id: null, tipo_guia: '31', sucursal_id: primeraSuccursal, vendedor_id: usuarioId || '', serie: '', numero: '', fecha_emision: today(),
      moneda: 'PEN', tipo_cambio: 1,
      motivo_traslado: '01', descripcion_motivo: '', peso_bruto_total: '', bultos: 1,
      unidad_medida_peso: 'KGM', fecha_inicio_traslado: today(),
      punto_partida_almacen_id: '', punto_partida_ubigeo: '', punto_partida_direccion: '',
      punto_llegada_almacen_id: '', punto_llegada_ubigeo: '', punto_llegada_direccion: '',
      cliente_id: '', destinatario_tipo_doc: '6', destinatario_numero_doc: '', destinatario_razon_social: '',
      tipo_transporte: 'Publico',
      transportista_ruc: '', transportista_razon_social: '', transportista_registro_mtc: '',
      vehiculo_placa: '', chofer_tipo_doc: '1', chofer_numero_doc: '',
      chofer_nombres: '', chofer_licencia: '',
      vehiculo_secundario_placa: '',
      transbordo_programado: false,
      pagador_flete: 'remitente',
      tercero_tipo_doc: '6', tercero_numero_doc: '', tercero_razon_social: '',
      retorno_vehiculo_vacio: false, retorno_envases_vacios: false,
      remitente_tipo_doc: '6', remitente_numero_doc: '', remitente_razon_social: '',
      observaciones: '', dato_adicional_placa: '', comprobante_relacionado_id: '', comprobante_relacionado_ref: '', adjuntos: [],
    });
    setDetalles([]);
    setDetalleForm({ ...initialDetalle });
    setDetalleIdx(null);
    setAdjuntos([]);
    setPlacaAdicional('');
    setFormError('');
    setLlegadaWasEdited(false);
    setDireccionesCliente([]);
  };

  // Al seleccionar almacén de partida/llegada, completar ubigeo y dirección
  const handleAlmacenPartida = (id) => {
    const alm = almacenes.find(a => a.id === Number(id));
    setForm(f => ({
      ...f,
      punto_partida_almacen_id: id,
      punto_partida_ubigeo: alm?.ubigeo || f.punto_partida_ubigeo,
      punto_partida_direccion: alm?.direccion || f.punto_partida_direccion,
    }));
  };

  const handleAlmacenLlegada = (id) => {
    const alm = almacenes.find(a => a.id === Number(id));
    setForm(f => ({
      ...f,
      punto_llegada_almacen_id: id,
      punto_llegada_ubigeo: alm?.ubigeo || f.punto_llegada_ubigeo,
      punto_llegada_direccion: alm?.direccion || f.punto_llegada_direccion,
    }));
  };

  const almacenesPartidaDisponibles = almacenes.filter(a => {
    const activo = Number(a.estado ?? 1) === 1;
    if (!activo) return false;
    if (!form.sucursal_id) return true;
    if (a.sucursal_id == null) return true;
    return Number(a.sucursal_id) === Number(form.sucursal_id);
  });

  useEffect(() => {
    if (!openForm || modoEdicion) return;
    if (!almacenesPartidaDisponibles.length) return;

    const seleccionadoValido = almacenesPartidaDisponibles.some(
      a => Number(a.id) === Number(form.punto_partida_almacen_id)
    );

    if (!seleccionadoValido) {
      handleAlmacenPartida(almacenesPartidaDisponibles[0].id);
    }
  }, [openForm, modoEdicion, form.sucursal_id, form.punto_partida_almacen_id, almacenes]);

  const handleSelectCliente = async (cli) => {
    if (!cli) return;
    let dirs = [];
    try {
      const r = await axios.get(`/api/auxiliares/${cli.id}/direcciones`);
      dirs = r.data || [];
    } catch {}
    setDireccionesCliente(dirs);
    setLlegadaWasEdited(false);
    const primera = dirs[0] || null;
    setForm(f => ({
      ...f,
      cliente_id: cli.id || '',
      destinatario_tipo_doc: String(cli.tipo_documento_identidad_id || cli.tipo_documento_codigo || '6'),
      destinatario_numero_doc: cli.numero_documento || '',
      destinatario_razon_social: cli.razon_social || `${cli.nombres || ''} ${cli.apellidos || ''}`.trim(),
      // Si ya hay un almacen de llegada seleccionado, su ubigeo/direccion manda:
      // no pisar el destino real con la direccion registrada del cliente.
      punto_llegada_ubigeo: f.punto_llegada_almacen_id ? f.punto_llegada_ubigeo : (primera?.ubigeo || cli.ubigeo || f.punto_llegada_ubigeo),
      punto_llegada_direccion: f.punto_llegada_almacen_id ? f.punto_llegada_direccion : (primera?.direccion || cli.direccion || f.punto_llegada_direccion),
    }));
  };

  const cargarDireccionesCliente = async (clienteId) => {
    if (!clienteId) { setDireccionesCliente([]); return; }
    try {
      const r = await axios.get(`/api/auxiliares/${clienteId}/direcciones`);
      setDireccionesCliente(r.data || []);
    } catch { setDireccionesCliente([]); }
  };

  const handleSelectDireccionLlegada = (dir) => {
    if (!dir) return;
    setForm(f => ({
      ...f,
      punto_llegada_direccion: dir.direccion,
      punto_llegada_ubigeo: dir.ubigeo || f.punto_llegada_ubigeo,
    }));
  };

  const handleUbigeoInputDirDlg = async (_, value) => {
    setUbigeoInputDirDlg(value);
    if (value && value.length >= 2) {
      try {
        const res = await axios.get(`/api/ubigeo?q=${encodeURIComponent(value)}`);
        setUbigeosDirDlg(res.data || []);
      } catch { setUbigeosDirDlg([]); }
    } else setUbigeosDirDlg([]);
  };

  const abrirEditarDireccion = async (d) => {
    setDirForm({ id: d.id, descripcion: d.descripcion || 'Principal', direccion: d.direccion, ubigeo: d.ubigeo || '', ubigeo_desc: d.ubigeo_desc || '', es_principal: !!d.es_principal });
    setUbigeosDirDlg([]);
    if (d.ubigeo) {
      try {
        const res = await axios.get(`/api/ubigeo?q=${encodeURIComponent(d.ubigeo)}`);
        const found = (res.data || []).find(u => u.codigo === d.ubigeo);
        setUbigeoSelDirDlg(found || null);
        setUbigeoInputDirDlg(found ? `${found.departamento}, ${found.provincia}, ${found.distrito} (${found.codigo})` : d.ubigeo_desc || d.ubigeo || '');
      } catch { setUbigeoSelDirDlg(null); setUbigeoInputDirDlg(d.ubigeo_desc || d.ubigeo || ''); }
    } else {
      setUbigeoSelDirDlg(null);
      setUbigeoInputDirDlg('');
    }
  };

  const cancelarEditarDireccion = () => {
    setDirForm({ id: null, descripcion: 'Principal', direccion: '', ubigeo: '', ubigeo_desc: '', es_principal: false });
    setUbigeoSelDirDlg(null);
    setUbigeoInputDirDlg('');
    setUbigeosDirDlg([]);
  };

  const guardarDireccionT = async () => {
    setDirError('');
    if (!dirForm.direccion.trim()) { setDirError('La dirección es obligatoria'); return; }
    const clienteId = form.cliente_id;
    if (!clienteId) { setDirError('Primero seleccione un cliente'); return; }
    try {
      if (dirForm.id) {
        await axios.put(`/api/auxiliares/direcciones/${dirForm.id}`, { ...dirForm, auxiliar_id: clienteId });
      } else {
        await axios.post(`/api/auxiliares/${clienteId}/direcciones`, dirForm);
      }
      await cargarDireccionesCliente(clienteId);
      cancelarEditarDireccion();
      setDirError('');
    } catch (e) {
      setDirError(e.response?.data?.error || 'Error al guardar dirección');
    }
  };

  const eliminarDireccionT = async (id) => {
    if (!window.confirm('¿Eliminar esta dirección?')) return;
    try {
      await axios.delete(`/api/auxiliares/direcciones/${id}`);
      await cargarDireccionesCliente(form.cliente_id);
    } catch (e) {
      alert(e.response?.data?.error || 'Error al eliminar');
    }
  };

  const handleMonedaChange = async (monedaCod) => {
    setForm(f => ({ ...f, moneda: monedaCod }));
    if (String(monedaCod).toUpperCase() !== 'USD') {
      setForm(f => ({ ...f, tipo_cambio: 1 }));
      return;
    }
    try {
      const resBD = await axios.get('/api/tipo-cambio');
      const tc = (resBD.data || []).find(x => x.fecha && x.fecha.substring(0, 10) === form.fecha_emision);
      if (tc?.venta) {
        setForm(f => ({ ...f, tipo_cambio: tc.venta }));
        return;
      }
    } catch {}
    try {
      const resSunat = await axios.get(`/api/tipo-cambio/sunat?fecha=${form.fecha_emision}`);
      if (resSunat.data?.venta) {
        setForm(f => ({ ...f, tipo_cambio: resSunat.data.venta }));
        return;
      }
    } catch {}
  };

  const abrirConfigPuntos = () => {
    setPuntoForm({ id: null, nombre: '', descripcion: '', sucursal_id: form.sucursal_id || '', direccion: '', ubigeo: '', estado: 1 });
    setUbigeoInputPunto('');
    setUbigeoOptions([]);
    setOpenPuntosPartida(true);
  };

  const editarPunto = (a) => {
    setPuntoForm({
      id: a.id,
      nombre: a.nombre || '',
      descripcion: a.descripcion || '',
      sucursal_id: a.sucursal_id || '',
      direccion: a.direccion || '',
      ubigeo: a.ubigeo || '',
      estado: a.estado ?? 1,
    });
    setUbigeoInputPunto(a.ubigeo || '');
  };

  const guardarPunto = async () => {
    try {
      const payload = { ...puntoForm, estado: puntoForm.estado ?? 1 };
      if (!payload.nombre || !payload.direccion || !payload.ubigeo) {
        alert('Nombre, dirección y ubigeo son obligatorios');
        return;
      }
      if (payload.id) {
        await axios.put(`/api/almacen/${payload.id}`, payload);
      } else {
        await axios.post('/api/almacen', payload);
      }
      const res = await axios.get('/api/almacen');
      setAlmacenes(res.data || []);
      setPuntoForm({ id: null, nombre: '', descripcion: '', sucursal_id: form.sucursal_id || '', direccion: '', ubigeo: '', estado: 1 });
      setUbigeoInputPunto('');
      setUbigeoOptions([]);
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar punto de partida');
    }
  };

  const eliminarPunto = async (id) => {
    if (!window.confirm('¿Eliminar punto de partida?')) return;
    try {
      await axios.delete(`/api/almacen/${id}`);
      const res = await axios.get('/api/almacen');
      setAlmacenes(res.data || []);
    } catch (err) {
      alert(err.response?.data?.error || 'Error al eliminar punto de partida');
    }
  };

  // Al seleccionar vehículo del catálogo
  const handleSelectVehiculo = (placaVal) => {
    if (!placaVal) {
      setForm(f => ({ ...f, vehiculo_placa: '' }));
      return;
    }
    const veh = vehiculos.find(v => v.placa === placaVal);
    if (veh) {
      setForm(f => ({ ...f, vehiculo_placa: veh.placa }));
    }
  };

  // Consulta RENIEC para el formulario rápido de chofer
  const handleBuscarDniChofer = async () => {
    setChoferDniError('');
    const dni = (choferForm.numero_documento || '').trim();
    if (choferForm.tipo_documento !== '1' || dni.length !== 8) {
      setChoferDniError('Ingresa un DNI válido de 8 dígitos.');
      return;
    }
    setLoadingChoferDni(true);
    try {
      const data = await consultaDni(dni);
      if (data && data.success) {
        setChoferForm(f => ({
          ...f,
          nombres: data.nombres || '',
          apellidos: [data.apellidoPaterno, data.apellidoMaterno].filter(Boolean).join(' '),
        }));
      } else {
        setChoferDniError('No se encontró en RENIEC. Ingresa los datos manualmente.');
      }
    } catch {
      setChoferDniError('Error al consultar RENIEC.');
    }
    setLoadingChoferDni(false);
  };

  // Normaliza tipo_documento del catálogo (puede venir como texto 'DNI' o código '1')
  const normalizarTipoDocChofer = (val) => {
    if (!val) return '1';
    const v = String(val).toUpperCase().trim();
    if (v === 'DNI') return '1';
    if (v === 'CE' || v === 'CARNET' || v === 'EXTRANJERIA' || v === 'CARNET EXTRANJERIA') return '4';
    if (v === 'PASAPORTE' || v === 'PASSPORT') return '7';
    return v;
  };

  // Al seleccionar chofer del catálogo
  const handleSelectChofer = (id) => {
    const cho = choferes.find(c => c.id === Number(id));
    if (cho) {
      setForm(f => ({
        ...f,
        chofer_tipo_doc: normalizarTipoDocChofer(cho.tipo_documento) || '1',
        chofer_numero_doc: cho.numero_documento || '',
        chofer_nombres: cho.nombres || '',
        chofer_apellidos: cho.apellidos || '',
        chofer_licencia: cho.licencia || '',
      }));
    }
  };

  // Al seleccionar transportista del catálogo
  const handleSelectTransportista = (ruc) => {
    const t = transportistas.find(x => x.ruc === ruc);
    if (t) {
      setForm(f => ({
        ...f,
        transportista_ruc: t.ruc,
        transportista_razon_social: t.razon_social,
        transportista_registro_mtc: t.numero_registro_mtc || '',
      }));
    }
  };

  // ── Abrir / editar ─────────────────────────────────────────────────────
  const abrirNuevo = () => {
    resetForm();
    setModoEdicion(false);
    setSerieInput('');
    setOpenForm(true);
    // Disparar carga de series si ya hay sucursal cargada
    const primeraSuccursal = sucursales.length > 0 ? sucursales[0].id : '';
    if (primeraSuccursal && usuarioId) {
      cargarSeriesPorSucursalUsuario(primeraSuccursal, usuarioId, '31');
    }
  };

  const abrirEditar = async (guia) => {
    try {
      const resp = await axios.get(`/api/guia-remision/${guia.id}`);
      const { cabecera: c, detalles: d } = resp.data;
      if (String(c.tipo_guia || '31') !== '31') {
        alert('Este formulario es exclusivo para Guía de Remisión Transportista (31).');
        return;
      }
      setForm({
        id: c.id,
        tipo_guia: c.tipo_guia || '31',
        sucursal_id: c.sucursal_id || '',
        vendedor_id: c.vendedor_id || usuarioId || '',
        serie: c.serie || '',
        numero: c.numero || '',
        fecha_emision: c.fecha_emision ? c.fecha_emision.slice(0,10) : today(),
        moneda: c.moneda || 'PEN',
        tipo_cambio: c.tipo_cambio || 1,
        motivo_traslado: c.motivo_traslado || '01',
        descripcion_motivo: c.descripcion_motivo || '',
        peso_bruto_total: c.peso_bruto_total ?? '',
        bultos: c.bultos ?? 1,
        unidad_medida_peso: c.unidad_medida_peso || 'KGM',
        fecha_inicio_traslado: c.fecha_inicio_traslado ? c.fecha_inicio_traslado.slice(0,10) : today(),
        punto_partida_almacen_id: '',
        punto_partida_ubigeo: c.punto_partida_ubigeo || '',
        punto_partida_direccion: c.punto_partida_direccion || '',
        punto_llegada_almacen_id: '',
        punto_llegada_ubigeo: c.punto_llegada_ubigeo || '',
        punto_llegada_direccion: c.punto_llegada_direccion || '',
        cliente_id: c.cliente_id || '',
        destinatario_tipo_doc: c.destinatario_tipo_doc || '6',
        destinatario_numero_doc: c.destinatario_numero_doc || '',
        destinatario_razon_social: c.destinatario_razon_social || '',
        tipo_transporte: c.tipo_transporte || 'Publico',
        transportista_ruc: c.transportista_ruc || '',
        transportista_razon_social: c.transportista_razon_social || '',
        transportista_registro_mtc: c.transportista_registro_mtc || '',
        vehiculo_placa: c.vehiculo_placa || '',
        chofer_tipo_doc: c.chofer_tipo_doc || '1',
        chofer_numero_doc: c.chofer_numero_doc || '',
        chofer_nombres: c.chofer_nombres || '',
        chofer_licencia: c.chofer_licencia || '',
        vehiculo_secundario_placa: c.vehiculo_secundario_placa || '',
        transbordo_programado: !!c.transbordo_programado,
        pagador_flete: c.pagador_flete || 'remitente',
        tercero_tipo_doc: c.tercero_tipo_doc || '6',
        tercero_numero_doc: c.tercero_numero_doc || '',
        tercero_razon_social: c.tercero_razon_social || '',
        retorno_vehiculo_vacio: !!c.retorno_vehiculo_vacio,
        retorno_envases_vacios: !!c.retorno_envases_vacios,
        remitente_tipo_doc: c.remitente_tipo_doc || '6',
        remitente_numero_doc: c.remitente_numero_doc || '',
        remitente_razon_social: c.remitente_razon_social || '',
        observaciones: c.observaciones || '',
        dato_adicional_placa: c.dato_adicional_placa || '',
        comprobante_relacionado_id: c.comprobante_relacionado_id || '',
        comprobante_relacionado_ref: c.comprobante_relacionado_ref || '',
        adjuntos: Array.isArray(c.adjuntos) ? c.adjuntos : [],
      });
      setAdjuntos(Array.isArray(c.adjuntos) ? c.adjuntos : []);
      setDetalles(d || []);
      setModoEdicion(true);
      setOpenForm(true);
    } catch (err) {
      alert('Error al cargar guía: ' + (err.response?.data?.error || err.message));
    }
  };

  // ── Guardar ────────────────────────────────────────────────────────────
  const guardar = async () => {
    if (saving) return; // Evita doble envío por doble clic mientras se está grabando
    setFormError('');
    const validationError = validateGuiaForm(form, detalles);
    if (validationError) return setFormError(validationError);

    setSaving(true);
    try {
      const payload = {
        ...form,
        detalles,
        usuario_creacion:    usuario,
        usuario_modificacion: usuario,
      };

      if (modoEdicion) {
        await axios.put(`/api/guia-remision/${form.id}`, payload);
      } else {
        await axios.post('/api/guia-remision', payload);
      }
      setOpenForm(false);
      cargarGuias();
    } catch (err) {
      setFormError(err.response?.data?.detalle || err.response?.data?.error || 'Error al guardar guía');
    } finally {
      setSaving(false);
    }
  };

  // ── Eliminar ───────────────────────────────────────────────────────────
  const eliminar = async (guia) => {
    if (!window.confirm(`¿Eliminar guía ${guia.serie}-${String(guia.numero).padStart(8,'0')}?`)) return;
    try {
      await axios.delete(`/api/guia-remision/${guia.id}`);
      cargarGuias();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al eliminar');
    }
  };

  const puedeReenviarCpe = (guia) => {
    const estado = String(guia?.estado_cpe || '').toUpperCase();
    return ['RECHAZADO', 'REINTENTAR', 'ERROR_REINTENTO', 'ERROR_ENVIO', 'ERROR_VALIDACION',
            'EN_COLA', 'PENDIENTE'].includes(estado)
      || estado.startsWith('ERROR_');
  };

  const reenviarCpeGuia = async (guia) => {
    try {
      setReenviandoGuiaId(guia.id);
      await axios.post(`/api/guia-remision/${guia.id}/encolar-envio`, { usuario, force: true });
      try {
        await axios.post('/api/guia-remision/envio-jobs/procesar-siguiente');
      } catch (_) {
        // Si falla proceso inmediato, lo tomará el scheduler automático.
      }
      await cargarGuias();
      alert('Guía reencolada para envío a SUNAT.');
    } catch (err) {
      alert(err.response?.data?.error || 'No se pudo reencolar la guía');
    } finally {
      setReenviandoGuiaId(null);
    }
  };

  const consultarTicketGuia = async (guia) => {
    try {
      await axios.post(`/api/guia-remision/${guia.id}/consultar-ticket`);
      await cargarGuias();
      alert('Consulta de ticket ejecutada correctamente.');
    } catch (err) {
      alert(err.response?.data?.error || 'No se pudo consultar ticket de la guía');
    }
  };

  const confirmarAnularEnSistema = async () => {
    const guia = anularDialog.data;
    if (!guia) return;
    try {
      setAnulandoGuiaId(guia.id);
      await axios.post(`/api/guia-remision/${guia.id}/anular-sistema`, { usuario, confirmado: true });
      setAnularDialog({ open: false, data: null, confirmado: false });
      await cargarGuias();
      alert('Guía anulada en el sistema.');
    } catch (err) {
      alert(err.response?.data?.error || 'No se pudo anular la guía en el sistema.');
    } finally {
      setAnulandoGuiaId(null);
    }
  };

  const descargarArchivoGuia = (guiaId, tipo) => {
    const tk = localStorage.getItem('token') || '';
    window.open(`/api/guia-remision/${guiaId}/archivo-cpe/${tipo}?token=${tk}`, '_blank');
  };

  const abrirDialogoPdfGuia = (guia) => {
    const formatoGuardado = localStorage.getItem('guia_pdf_formato_default') || 'A4';
    setGuiaPdfTarget(guia);
    setPdfFormatoSeleccionado(formatoGuardado);
    setOpenPdfDialog(true);
  };

  const descargarPdfGuia = () => {
    if (!guiaPdfTarget) return;

    const formato = String(pdfFormatoSeleccionado || 'A4').toUpperCase();
    localStorage.setItem('guia_pdf_formato_default', formato);

    const query = new URLSearchParams({
      formato,
      mode: 'download'
    }).toString();

    const tk = localStorage.getItem('token') || '';
    window.open(`/api/guia-remision/${guiaPdfTarget.id}/pdf?${query}&token=${tk}`, '_blank');
    setOpenPdfDialog(false);
    setGuiaPdfTarget(null);
  };

  // ── Detalle (captura inline) ──────────────────────────────────────────
  const prepararDetalleDesdeProducto = (productoId) => {
    const prod = productosCatalogo.find(p => Number(p.id) === Number(productoId));
    setDetalleForm(prev => ({
      ...prev,
      producto_id: productoId || '',
      descripcion_producto: copiarNombreADesc ? (prod?.nombre || prod?.descripcion || '') : (prev.descripcion_producto || prod?.nombre || prod?.descripcion || ''),
      unidad_medida_id: prev.unidad_medida_id || prod?.unidad_medida_id || prev.unidad_medida_id,
      unidad_medida: prev.unidad_medida || prod?.unidad_medida || prev.unidad_medida
    }));
  };

  const handleBuscadorSelectGuia = (prod) => {
    setDetalleForm(prev => ({
      ...prev,
      producto_id: prod.id,
      descripcion_producto: copiarNombreADesc ? (prod.nombre || '') : (prev.descripcion_producto || prod.nombre || ''),
      unidad_medida_id: prev.unidad_medida_id || prod.unidad_medida_id || '',
      unidad_medida: prev.unidad_medida || prod.unidad_medida || 'NIU',
    }));
    setProductoInput(prod?.codigo ? `${prod.codigo} - ${prod.nombre || ''}` : (prod?.nombre || ''));
  };

  const abrirEditarDetalle = (idx) => {
    setDetalleForm({ ...initialDetalle, ...detalles[idx] });
    setDetalleIdx(idx);
  };

  const guardarDetalleInline = () => {
    if (!detalleForm.producto_id) {
      alert('Debe seleccionar el producto de la lista (campo "Producto" o buscador F1) antes de agregarlo. No escriba la descripción manualmente, o el código no saldrá en el PDF de la guía.');
      return;
    }
    if (!detalleForm.descripcion_producto?.trim()) {
      alert('La descripción es requerida');
      return;
    }
    if (!detalleForm.cantidad || Number(detalleForm.cantidad) <= 0) {
      alert('La cantidad debe ser mayor a 0');
      return;
    }
    // Traslado entre establecimientos (04): un solo movimiento entre dos
    // almacenes puntuales — el almacén de cada línea debe coincidir con el
    // punto de partida de la cabecera (el kardex siempre usa el de cabecera
    // para este motivo, no el de la línea).
    if (
      form.motivo_traslado === '04' &&
      detalleForm.almacen_id &&
      form.punto_partida_almacen_id &&
      String(detalleForm.almacen_id) !== String(form.punto_partida_almacen_id)
    ) {
      const nombreAlmacen = almacenes.find(a => Number(a.id) === Number(form.punto_partida_almacen_id))?.nombre || form.punto_partida_almacen_id;
      alert(`El almacén elegido no coincide con el punto de partida de la guía (${nombreAlmacen}). Para traslado entre establecimientos, todas las líneas deben usar ese mismo almacén.`);
      return;
    }

    const det = {
      ...detalleForm,
      cantidad: Number(detalleForm.cantidad) || 1,
    };

    if (detalleIdx === null) {
      setDetalles(prev => [...prev, det]);
    } else {
      setDetalles(prev => prev.map((d, i) => i === detalleIdx ? det : d));
    }

    setDetalleForm({ ...initialDetalle, almacen_id: form.punto_partida_almacen_id || '' });
    setDetalleIdx(null);
  };

  const eliminarDetalle = (idx) => {
    setDetalles(prev => prev.filter((_, i) => i !== idx));
    if (detalleIdx === idx) {
      setDetalleForm({ ...initialDetalle, almacen_id: form.punto_partida_almacen_id || '' });
      setDetalleIdx(null);
    }
  };

  const handleOpenDatosAdicionales = () => {
    setPlacaAdicional(form.dato_adicional_placa || '');
    setOpenDatosAdicionales(true);
  };

  // ── Exportar Excel ────────────────────────────────────────────────────
  const exportarExcel = async () => {
    await exportGuiasWorkbook({
      guias,
      searchText: busqueda,
      usuario: usuarioLogueado?.username || '',
      config: GUIA_CONFIG.TRANSPORTISTA
    });
  };

  // ── CRUD auxiliares ────────────────────────────────────────────────────
  const guardarVehiculo = async () => {
    try {
      await axios.post('/api/guia-remision/vehiculos', vehiculoForm);
      setOpenVehiculo(false);
      const resp = await axios.get('/api/guia-remision/catalogo/vehiculos');
      setVehiculos(resp.data || []);
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar vehículo'); }
  };

  const guardarChofer = async () => {
    try {
      await axios.post('/api/guia-remision/choferes', choferForm);
      setOpenChofer(false);
      const resp = await axios.get('/api/guia-remision/catalogo/choferes');
      setChoferes(resp.data || []);
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar chofer'); }
  };

  const guardarTransportista = async () => {
    try {
      await axios.post('/api/guia-remision/transportistas', transportistaForm);
      setOpenTransportista(false);
      const resp = await axios.get('/api/guia-remision/catalogo/transportistas');
      setTransportistas(resp.data || []);
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar transportista'); }
  };

  // ── UI: chip estado CPE ───────────────────────────────────────────────
  const chipEstado = (estado) => {
    const cfg = ESTADO_CHIPS[estado] || { label: estado || 'Pendiente', color: 'default' };
    return <Chip label={cfg.label} color={cfg.color} size="small" />;
  };

  const esGuiaTransportista = form.tipo_guia === '31';
  const esTransportePublico = isPublicTransport(form.tipo_guia, form.tipo_transporte);
  const mostrarBloqueTransportista = esTransportePublico;
  // Para tipo 31 (Transportista), el vehículo primario y chofer son SIEMPRE requeridos.
  // Para tipo 09 Privado también. Ambos casos deben mostrar el bloque.
  const mostrarBloqueVehiculoChofer = esGuiaTransportista || form.tipo_transporte === 'Privado';
  const mostrarOpcionesEspeciales31 = esGuiaTransportista;
  const mostrarOtroTercero = esGuiaTransportista && form.pagador_flete === 'otro_tercero';
  const descripcionMotivoObligatoria = motivoRequiereDescripcion(form.motivo_traslado);
  const choferSeleccionado = choferes.find(c => String(c.numero_documento || '') === String(form.chofer_numero_doc || ''));

  // ── RENDER ─────────────────────────────────────────────────────────────
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>
          Guías de Remisión - Transportista
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            label="Tipo"
            size="small"
            value={`${filtroTipo} - Transportista`}
            disabled
            sx={{ minWidth: 220 }}
          />

          <TextField
            placeholder="Buscar por serie, número, destinatario o documento..."
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && cargarGuias()}
            size="small"
            sx={{ flex: 1, minWidth: 220 }}
          />

          <Button variant="outlined" color="primary" startIcon={<Search />} onClick={cargarGuias} sx={{ minWidth: 120, borderRadius: 2 }}>
            Buscar
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={isRefreshingList ? <CircularProgress size={16} /> : <Refresh />}
            onClick={cargarGuias}
            disabled={isRefreshingList}
            sx={{ minWidth: 170, borderRadius: 2 }}
          >
            {isRefreshingList ? 'Actualizando...' : 'Actualizar listado'}
          </Button>
          <Button variant="contained" color="success" startIcon={<GridOn />} onClick={exportarExcel} sx={{ minWidth: 150 }}>
            Exportar Excel
          </Button>
          <Button variant="contained" color="primary" startIcon={<Add />} onClick={abrirNuevo} sx={{ minWidth: 210 }}>
            Nueva Guía Transportista
          </Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPageGuias}
            onChange={e => { setRowsPerPageGuias(Number(e.target.value)); setPageGuias(0); }}
            sx={{ width: 100 }}
            inputProps={{ min: 1 }}
          />
        </Box>

        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Tipo</TableCell>
                <TableCell align="center">Serie-Número</TableCell>
                <TableCell align="center">Fecha Emisión</TableCell>
                <TableCell align="center">Motivo</TableCell>
                <TableCell align="center">Destinatario</TableCell>
                <TableCell align="center">Vehículo</TableCell>
                <TableCell align="center">Estado CPE</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingGuias ? (
                <TableRow><TableCell colSpan={8} align="center"><CircularProgress size={24} /></TableCell></TableRow>
              ) : guias.length === 0 ? (
                <TableRow><TableCell colSpan={8} align="center">No hay guías registradas</TableCell></TableRow>
              ) : guias.slice(pageGuias * rowsPerPageGuias, (pageGuias + 1) * rowsPerPageGuias).map(g => (
                <TableRow key={g.id} hover>
                  <TableCell align="center">
                    <Chip label={g.tipo_guia === '09' ? 'Remitente' : 'Transportista'}
                          color={g.tipo_guia === '09' ? 'primary' : 'secondary'} size="small" />
                  </TableCell>
                  <TableCell align="center">{g.serie}-{String(g.numero).padStart(8,'0')}</TableCell>
                  <TableCell align="center">{fmtFecha(g.fecha_emision)}</TableCell>
                  <TableCell align="center">{g.motivo_traslado_desc || g.motivo_traslado}</TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">{g.destinatario_razon_social || '—'}</Typography>
                    {g.destinatario_numero_doc && <Typography variant="caption" color="text.secondary">{g.destinatario_numero_doc}</Typography>}
                  </TableCell>
                  <TableCell align="center">{g.vehiculo_placa || '—'}</TableCell>
                  <TableCell align="center">{chipEstado(g.estado_cpe)}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Descargar PDF">
                      <IconButton size="small" color="secondary" onClick={() => abrirDialogoPdfGuia(g)}>
                        <CloudUpload fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Descargar XML">
                      <IconButton size="small" color="info" onClick={() => descargarArchivoGuia(g.id, 'xml')}>
                        <Description fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Descargar CDR">
                      <IconButton size="small" color="success" onClick={() => descargarArchivoGuia(g.id, 'cdr')}>
                        <Archive fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Descargar ZIP">
                      <IconButton size="small" color="primary" onClick={() => descargarArchivoGuia(g.id, 'zip')}>
                        <AttachFile fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Reenviar CPE a SUNAT">
                      <span>
                        <IconButton
                          size="small"
                          color="warning"
                          disabled={!puedeReenviarCpe(g) || reenviandoGuiaId === g.id}
                          onClick={() => reenviarCpeGuia(g)}
                        >
                          {reenviandoGuiaId === g.id ? <CircularProgress size={16} /> : <Refresh fontSize="small" />}
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Consultar ticket SUNAT">
                      <IconButton
                        size="small"
                        color="warning"
                        disabled={!g.ticket_sunat}
                        onClick={() => consultarTicketGuia(g)}
                      >
                        <Search fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={g.estado_cpe === 'ACEPTADO' ? 'Anular en el sistema (requiere anulación previa en SUNAT vía Clave SOL)' : 'Solo se puede anular una guía aceptada por SUNAT'}>
                      <span>
                        <IconButton
                          size="small"
                          color="error"
                          disabled={g.estado_cpe !== 'ACEPTADO' || anulandoGuiaId === g.id}
                          onClick={() => setAnularDialog({ open: true, data: g, confirmado: false })}
                        >
                          {anulandoGuiaId === g.id ? <CircularProgress size={16} /> : <Cancel fontSize="small" />}
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => abrirEditar(g)}
                        disabled={g.estado_cpe === 'ACEPTADO'}>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                      <IconButton size="small" color="error" onClick={() => eliminar(g)}
                        disabled={g.estado_cpe === 'ACEPTADO'}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Enviar por WhatsApp">
                      <IconButton size="small" sx={{ color: '#25d366' }}
                        onClick={() => setWspDialog({ open: true, data: g })}>
                        <WhatsAppIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Enviar por correo electrónico">
                      <IconButton size="small" color="primary"
                        onClick={() => setEmailDialog({ open: true, data: g })}>
                        <EmailIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
          <Typography variant="body2" sx={{ ml: 1 }}>
            {guias.length === 0
              ? 'Mostrando 0-0 de 0 guías'
              : `Mostrando ${pageGuias * rowsPerPageGuias + 1}-${Math.min((pageGuias + 1) * rowsPerPageGuias, guias.length)} de ${guias.length} guías`}
          </Typography>
          <Box>
            <Button disabled={pageGuias === 0} onClick={() => setPageGuias(p => p - 1)}>Anterior</Button>
            <Button disabled={(pageGuias + 1) * rowsPerPageGuias >= guias.length} onClick={() => setPageGuias(p => p + 1)}>Siguiente</Button>
          </Box>
        </Box>
      </Box>

      {/* ── FORMULARIO PRINCIPAL ──────────────────────────────────────── */}
      <Dialog open={openForm} onClose={(e, reason) => { if (reason === 'backdropClick') return; setOpenForm(false); resetForm(); }} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 22, letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalShipping /> {modoEdicion ? 'Editar Guía de Remisión Transportista' : 'Nueva Guía de Remisión Transportista'}
        </DialogTitle>
        <DialogContent dividers>
          {formError && <Alert severity="error" sx={{ mb:2 }}>{formError}</Alert>}
          <Alert severity="info" sx={{ mb:2 }}>
            Modo Transportista (31): este formulario está dedicado a Guía de Remisión Transportista.
          </Alert>

          <Paper variant="outlined" sx={{ p:2, mb:2, borderRadius: 2 }}>
          <Typography variant="subtitle2" color="primary" gutterBottom sx={{ fontWeight: 700, mb: 1.5 }}>Datos Comerciales / Principales</Typography>
          <Grid container spacing={2}>
            <Grid item xs={4} sm={3} sx={{ width: '29em', minWidth: '29em' }}>
              <Autocomplete
                options={sucursales}
                getOptionLabel={option => option.nombre ? `${option.nombre}` : ''}
                value={sucursales.find(s => s.id === form.sucursal_id) || null}
                inputValue={sucursalInput}
                onInputChange={(e, value) => setSucursalInput(value)}
                onChange={(e, value) => { if (value) setForm(f => ({ ...f, sucursal_id: value.id })); }}
                loading={loadingSucursales}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Sucursal" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} size="small" />
                )}
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <TextField fullWidth required label="Fecha Emisión" name="fecha_emision" type="date" value={form.fecha_emision} onChange={handleChange} size="small" InputLabelProps={{ shrink:true }} />
            </Grid>
            <Grid item xs={2} sm={3}>
              <TextField fullWidth required label="Fecha Inicio Traslado" name="fecha_inicio_traslado" type="date"
                value={form.fecha_inicio_traslado} onChange={handleChange} size="small"
                InputLabelProps={{ shrink:true }} />
            </Grid>
            <Grid item xs={2} sm={2} sx={{ width: '8em', minWidth: '8em' }}>
              <Autocomplete
                options={seriesDisponibles}
                getOptionLabel={option => option.serie ? `${option.serie}` : ''}
                value={seriesDisponibles.find(s => s.serie === form.serie) || null}
                inputValue={serieInput}
                onInputChange={(e, value) => setSerieInput(value)}
                onChange={(e, value) => {
                  setForm(f => ({ ...f, serie: value ? value.serie : '' }));
                }}
                loading={loadingSeries}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Serie" fullWidth required size="small" InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2} sm={2} sx={{ width: '8em', minWidth: '8em' }}>
              <TextField fullWidth label="Número" value={form.numero || ''} size="small" disabled />
            </Grid>
            <Grid item xs={4} sm={8} sx={{ width: '29em', minWidth: '29em' }}>
              <Autocomplete
                options={clientes}
                getOptionLabel={o => `${o?.numero_documento || ''} - ${o?.razon_social || `${o?.nombres || ''} ${o?.apellidos || ''}`.trim()}`}
                value={clientes.find(c => Number(c.id) === Number(form.cliente_id)) || null}
                inputValue={clienteInput}
                onInputChange={(_, v) => setClienteInput(v)}
                onChange={(_, v) => { handleSelectCliente(v); }}
                noOptionsText={
                  clienteInput.length >= 2 ? (
                    <Button size="small" onMouseDown={(e) => e.preventDefault()} onClick={() => setOpenNuevoCliente(true)}>+ Registrar "{clienteInput}" como nuevo cliente</Button>
                  ) : 'Escribe para buscar'
                }
                renderInput={params => <TextField {...params} label="Cliente / Destinatario" size="small" fullWidth required />}
              />
            </Grid>
            <Grid item xs={3} sm={2} sx={{ width: '13em', minWidth: '13em' }}>
              <Autocomplete
                options={monedas}
                getOptionLabel={option => option.descripcion && option.codigo ? `${option.descripcion} (${option.codigo})` : option.descripcion || ''}
                value={monedas.find(m => m.codigo === form.moneda) || null}
                inputValue={monedaInput}
                onInputChange={(e, value) => setMonedaInput(value)}
                onChange={async (e, value) => {
                  const nuevaMoneda = value ? value.codigo : '';
                  setForm(f => ({ ...f, moneda: nuevaMoneda }));
                  if (nuevaMoneda === 'USD') {
                    const fecha = form.fecha_emision;
                    try {
                      const resBD = await axios.get('/api/tipo-cambio');
                      const tc = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === fecha);
                      if (tc && tc.venta) { setForm(f => ({ ...f, tipo_cambio: tc.venta })); return; }
                    } catch {}
                    try {
                      const res = await axios.get(`/api/tipo-cambio/sunat?fecha=${fecha}`);
                      if (res.data && res.data.venta) { setForm(f => ({ ...f, tipo_cambio: res.data.venta })); return; }
                    } catch {}
                    setForm(f => ({ ...f, tipo_cambio: 1 }));
                  } else {
                    setForm(f => ({ ...f, tipo_cambio: 1 }));
                  }
                }}
                loading={loadingMonedas}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Moneda" fullWidth required size="small" InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} sx={{ width: '8em', minWidth: '8em' }}>
              <TextField fullWidth label="Tipo Cambio" name="tipo_cambio" size="small" type="number" value={form.tipo_cambio} onChange={handleChange} inputProps={{ min:0, step:0.0001 }} disabled={String(form.moneda).toUpperCase() !== 'USD'} />
            </Grid>
            <Grid item xs={4} sm={3} sx={{ minWidth: '15.6em' }}>
              <Autocomplete
                options={vendedores}
                getOptionLabel={option => option.nombres && option.apellidos && option.username ? `${option.nombres} ${option.apellidos} (${option.username})` : option.nombres || ''}
                value={vendedores.find(v => v.id === form.vendedor_id) || null}
                inputValue={vendedores.find(v => v.id === form.vendedor_id) ? `${vendedores.find(v => v.id === form.vendedor_id).nombres} ${vendedores.find(v => v.id === form.vendedor_id).apellidos} (${vendedores.find(v => v.id === form.vendedor_id).username})` : ''}
                disabled
                renderInput={params => (
                  <TextField {...params} label="Vendedor" fullWidth required disabled size="small" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ width: '34em', minWidth: '34em' }}>
              <TextField select fullWidth label="Motivo de Traslado" name="motivo_traslado"
                value={form.motivo_traslado} onChange={handleChange} size="small" required>
                {motivosTraslado.map(m => (
                  <MenuItem key={m.codigo} value={m.codigo}>{m.codigo} - {m.descripcion}</MenuItem>
                ))}
                {motivosTraslado.length === 0 && [
                  <MenuItem key="01" value="01">01 - Venta</MenuItem>,
                  <MenuItem key="04" value="04">04 - Traslado entre establecimientos</MenuItem>,
                  <MenuItem key="13" value="13">13 - Otros</MenuItem>,
                ]}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={2}  sx={{ width: '10em', minWidth: '10em' }}>
              <TextField fullWidth required label="Peso Bruto (KGM)" name="peso_bruto_total" type="number"
                value={form.peso_bruto_total} onChange={handleChange} size="small"
                inputProps={{ min:0, step:0.01 }} />
            </Grid>
            <Grid item xs={12} sm={1} sx={{ width: '7em', minWidth: '7em' }}>
              <TextField fullWidth label="Bultos" name="bultos" type="number"
                value={form.bultos} onChange={handleChange} size="small"
                inputProps={{ min:1, step:1 }} />
            </Grid>
            <Grid item xs={12}  sx={{ width: '22.5em', minWidth: '22.5em' }}>
              <TextField fullWidth required={descripcionMotivoObligatoria} label={descripcionMotivoObligatoria ? 'Descripción del motivo' : 'Descripción del motivo (opcional)'} name="descripcion_motivo"
                value={form.descripcion_motivo} onChange={handleChange} size="small" />
            </Grid>
          </Grid>
          </Paper>
          {/* Sección: Puntos de partida y llegada */}
          <Paper variant="outlined" sx={{ p:2, mb:2, borderRadius: 2 }}>
          <Box sx={{ display:'flex', alignItems:'center', cursor:'pointer', mb:1 }}
            onClick={() => setExpandPartidaLlegada(v => !v)}>
            <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700 }}>Punto de Partida y Llegada</Typography>
            <IconButton size="small">{expandPartidaLlegada ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
          {expandPartidaLlegada && (
          <Grid container spacing={2}>
            <Grid item xs={3} sm={4} sx={{ width: '25em', minWidth: '25em' }}>
              <TextField select fullWidth label="Almacén Partida" size="small"
                value={form.punto_partida_almacen_id}
                onChange={e => handleAlmacenPartida(e.target.value)}>
                {almacenesPartidaDisponibles.map(a => (
                  <MenuItem key={a.id} value={a.id}>{a.nombre}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={2} sm={2} sx={{ width: '13em', minWidth: '13em' }}>
              <Button fullWidth variant="contained" color="warning" onClick={abrirConfigPuntos} sx={{ height: '40px', fontWeight: 'bold' }}>
                Configurar puntos
              </Button>
            </Grid>
            {form.motivo_traslado === '04' && (
              <Grid item xs={3} sm={4} sx={{ width: '25em', minWidth: '25em' }}>
                <TextField select fullWidth required label="Almacén Llegada (Motivo 04)" size="small"
                  value={form.punto_llegada_almacen_id}
                  onChange={e => handleAlmacenLlegada(e.target.value)}>
                  <MenuItem value="">-- Seleccionar --</MenuItem>
                  {almacenes.filter(a => Number(a.estado ?? 1) === 1).map(a => (
                    <MenuItem key={a.id} value={a.id}>{a.nombre}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <Box sx={{ flexBasis: '100%', height: 0 }} />
            <Grid item xs={1} sm={2} sx={{ width: '8em', minWidth: '8em', mt:-2 }}>
              <TextField fullWidth label="Ubigeo Partida" name="punto_partida_ubigeo"
                value={form.punto_partida_ubigeo} onChange={handleChange} size="small"
                required inputProps={{ maxLength:6 }} placeholder="070101" />
            </Grid>
            <Grid item xs={6} sm={4} sx={{ width: '23em', minWidth: '23em', mt:-2  }}>
              <TextField fullWidth required label="Dirección Partida" name="punto_partida_direccion"
                value={form.punto_partida_direccion} onChange={handleChange} size="small" />
            </Grid>
            <Grid item xs={1} sm={3} sx={{ width: '8em', minWidth: '8em', mt:-2  }}>
              <TextField fullWidth label="Ubigeo Llegada" name="punto_llegada_ubigeo"
                value={form.punto_llegada_ubigeo} onChange={handleChange} size="small"
                required inputProps={{ maxLength:6 }} placeholder="070101" />
            </Grid>
            <Grid item xs={6} sm={9} sx={{ width: '23em', minWidth: '23em', mt:-2, flexShrink: 0 }}>
              <Autocomplete
                freeSolo
                options={direccionesCliente}
                getOptionLabel={opt => typeof opt === 'string' ? opt : (opt.direccion || '')}
                inputValue={form.punto_llegada_direccion || ''}
                value={null}
                onInputChange={(_, v, reason) => {
                  if (reason === 'input') setLlegadaWasEdited(true);
                  setForm(f => ({ ...f, punto_llegada_direccion: v }));
                }}
                onChange={(_, val) => {
                  if (!val) return;
                  if (typeof val === 'string') {
                    setForm(f => ({ ...f, punto_llegada_direccion: val }));
                  } else if (val._isNew) {
                    setDirForm(f => ({ ...f, direccion: form.punto_llegada_direccion }));
                    setOpenDirecciones(true);
                  } else {
                    setLlegadaWasEdited(false);
                    handleSelectDireccionLlegada(val);
                  }
                }}
                filterOptions={(options, { inputValue }) => {
                  const q = (inputValue || '').toLowerCase();
                  const filtered = options.filter(opt =>
                    !q || opt.direccion.toLowerCase().includes(q) || (opt.descripcion || '').toLowerCase().includes(q)
                  );
                  if (llegadaWasEdited && q && !options.some(opt => opt.direccion.toLowerCase() === q)) {
                    filtered.push({ _isNew: true, id: '__new__', direccion: inputValue });
                  }
                  return filtered;
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option._isNew ? '__new__' : option.id}>
                    {option._isNew ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                        <Add fontSize="small" />
                        <Typography variant="body2">Registrar: <strong>"{option.direccion}"</strong></Typography>
                      </Box>
                    ) : (
                      <Typography variant="body2" fontWeight={option.es_principal ? 600 : 400}>
                        {option.descripcion ? `${option.descripcion}: ` : ''}{option.direccion}{option.es_principal ? ' ★' : ''}
                      </Typography>
                    )}
                  </li>
                )}
                renderInput={params => (
                  <TextField {...params} fullWidth required label="Dirección Llegada" size="small" />
                )}
              />
            </Grid>
            <Grid item sx={{ mt: -2, display: 'flex', alignItems: 'center' }}>
              <Tooltip title={form.cliente_id ? 'Gestionar direcciones del cliente' : 'Primero seleccione un cliente'}>
                <span>
                  <IconButton size="small" color="primary" disabled={!form.cliente_id}
                    onClick={() => { cargarDireccionesCliente(form.cliente_id); setOpenDirecciones(true); }}>
                    <Add />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
          )}
          </Paper>

          {/* Sección: Transporte (colapsable) */}
          <Paper variant="outlined" sx={{ p:2, mb:2, borderRadius: 2, bgcolor: '#fafcff' }}>
          <Box sx={{ display:'flex', alignItems:'center', cursor:'pointer', mb:1 }}
            onClick={() => setExpandTransporte(e => !e)}>
            <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700 }}>Datos de Transporte</Typography>
            <IconButton size="small">{expandTransporte ? <ExpandLess /> : <ExpandMore />}</IconButton>
            <Chip
              label={esGuiaTransportista ? 'Guía Transportista (31)' : `Guía Remitente (09) - ${form.tipo_transporte}`}
              color={esGuiaTransportista ? 'secondary' : 'primary'}
              size="small"
              sx={{ ml: 1 }}
            />
          </Box>

          {expandTransporte && (
            <Grid container spacing={2}>
              <Grid item xs={2} sx={{ width: '8em', minWidth: '8em' }}>
                <TextField select fullWidth label="Tipo Transporte" name="tipo_transporte"
                  value={form.tipo_transporte} onChange={handleChange} size="small"
                  disabled={esGuiaTransportista}>
                  <MenuItem value="Privado">Privado</MenuItem>
                  <MenuItem value="Publico">Público</MenuItem>
                </TextField>
              </Grid>

              {/* Transportista (solo transporte público) */}
              {mostrarBloqueTransportista && (<>
                <Grid item xs={12} sm={9} sx={{ width: '30em', minWidth: '30em' }}>
                  <Box sx={{ display:'flex', gap:1 }}>
                    <TextField select fullWidth label="Transportista (catálogo)" size="small"
                      value={form.transportista_ruc}
                      onChange={e => handleSelectTransportista(e.target.value)}>
                      <MenuItem value="">-- Seleccionar --</MenuItem>
                      {transportistas.map(t => (
                        <MenuItem key={t.ruc} value={t.ruc}>{t.ruc} - {t.razon_social}</MenuItem>
                      ))}
                    </TextField>
                    <Tooltip title="Nuevo transportista">
                      <IconButton size="small" onClick={() => setOpenTransportista(true)}><Add /></IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
                <Box sx={{ flexBasis: '100%', height: 0 }} />
                <Grid item xs={12} sm={3} sx={{ width: '10em', minWidth: '10em', mt:-2 }}>
                  <TextField fullWidth required label="RUC Transportista" name="transportista_ruc"
                    value={form.transportista_ruc} onChange={handleChange} size="small" />
                </Grid>
                <Grid item xs={12} sm={6} sx={{ width: '40em', minWidth: '40em', mt:-2 }}>
                  <TextField fullWidth required label="Razón Social Transportista" name="transportista_razon_social"
                    value={form.transportista_razon_social} onChange={handleChange} size="small" />
                </Grid>
                <Grid item xs={12} sm={3} sx={{ width: '15em', minWidth: '15em', mt:-2 }}>
                  <TextField fullWidth label="N° Registro MTC" name="transportista_registro_mtc"
                    value={form.transportista_registro_mtc} onChange={handleChange} size="small" />
                </Grid>
              </>)}

              {/* Vehículo y chofer */}
              {mostrarBloqueVehiculoChofer && (<>
              {/* Remitente (tipo 31): quien encarga el traslado al transportista */}
              {esGuiaTransportista && (
                <>
                  <Box sx={{ flexBasis: '100%', height: 0 }} />
                  <Grid item xs={12} sm={2} sx={{ width: '12em', minWidth: '12em', mt:-2 }}>
                    <TextField select fullWidth label="Tipo Doc Remitente" name="remitente_tipo_doc"
                      value={form.remitente_tipo_doc} onChange={handleChange} size="small">
                      <MenuItem value="6">RUC</MenuItem>
                      <MenuItem value="1">DNI</MenuItem>
                      <MenuItem value="4">Carnet Extranjería</MenuItem>
                      <MenuItem value="7">Pasaporte</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={3} sx={{ width: '11em', minWidth: '11em', mt:-2 }}>
                    <TextField fullWidth required label="Nro. Doc. Remitente" name="remitente_numero_doc"
                      value={form.remitente_numero_doc} onChange={handleChange} size="small" />
                  </Grid>
                  <Grid item xs={12} sm={5} sx={{ width: '42em', minWidth: '42em', mt:-2 }}>
                    <TextField fullWidth required label="Razón Social / Nombre Remitente" name="remitente_razon_social"
                      value={form.remitente_razon_social} onChange={handleChange} size="small" />
                  </Grid>
                  <Box sx={{ flexBasis: '100%', height: 0 }} />
                </>
              )}

              <Grid item xs={12} sm={4} sx={{ width: '16em', minWidth: '16em', mt:-2 }}>
                <Box sx={{ display:'flex', gap:1, alignItems:'center' }}>
                  <TextField select fullWidth label="Vehículo (catálogo)" size="small"
                    value={form.vehiculo_placa}
                    onChange={e => handleSelectVehiculo(e.target.value)}
                    helperText={esGuiaTransportista && form.vehiculo_placa ? (() => { const v = vehiculos.find(x => x.placa === form.vehiculo_placa); return v?.nro_certificado_inscripcion ? `TUC: ${v.nro_certificado_inscripcion}` : null; })() : null}>
                    <MenuItem value="">-- Seleccionar --</MenuItem>
                    {vehiculos.map(v => (
                      <MenuItem key={v.placa} value={v.placa}>{v.placa} {v.marca ? `- ${v.marca}` : ''}</MenuItem>
                    ))}
                  </TextField>
                  <Tooltip title="Nuevo vehículo" sx={{ mt: -2 }}>
                    <IconButton size="small" onClick={() => setOpenVehiculo(true)}><Add /></IconButton>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12} sm={3} sx={{ width: '8em', minWidth: '8em', mt:-2 }}>
                <TextField fullWidth required label="Placa Vehículo" name="vehiculo_placa"
                  value={form.vehiculo_placa} onChange={handleChange} size="small" />
              </Grid>
              <Grid item xs={12} sm={5} sx={{ width: '25em', minWidth: '25em', mt:-2 }}>
                <Box sx={{ display:'flex', gap:1, alignItems:'center' }}>
                  <TextField select fullWidth label="Chofer (catálogo)" size="small"
                    value={choferSeleccionado?.id || ''}
                    onChange={e => handleSelectChofer(e.target.value)}>
                    <MenuItem value="">-- Seleccionar --</MenuItem>
                    {choferes.map(c => (
                      <MenuItem key={c.id} value={c.id}>{c.apellidos}, {c.nombres} - {c.numero_documento}</MenuItem>
                    ))}
                  </TextField>
                  <Tooltip title="Nuevo chofer">
                    <IconButton size="small" onClick={() => setOpenChofer(true)}><Add /></IconButton>
                  </Tooltip>
                </Box>
              </Grid>
              {esGuiaTransportista && (
                <Grid item xs={12} sm={4} sx={{ width: '15em', minWidth: '15em', mt:-2 }}>
                  <TextField
                    select
                    fullWidth
                    label="Vehículo Secundario / Carreta (opcional)"
                    name="vehiculo_secundario_placa"
                    value={form.vehiculo_secundario_placa}
                    onChange={handleChange}
                    size="small"
                    helperText={form.vehiculo_secundario_placa ? (() => { const v = vehiculos.find(x => x.placa === form.vehiculo_secundario_placa); return v?.nro_certificado_inscripcion ? `TUC: ${v.nro_certificado_inscripcion}` : null; })() : null}
                  >
                    <MenuItem value="">-- Ninguno --</MenuItem>
                    {vehiculos.map(v => (
                      <MenuItem key={`sec-${v.placa}`} value={v.placa}>{v.placa} {v.marca ? `- ${v.marca}` : ''}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              <Box sx={{ flexBasis: '100%', height: 0 }} />
              <Grid item xs={12} sm={2} sx={{ width: '12em', minWidth: '12em', mt:-2 }}>
                <TextField fullWidth label="Tipo Doc Chofer" name="chofer_tipo_doc"
                  value={form.chofer_tipo_doc} onChange={handleChange} size="small" select>
                  <MenuItem value="1">DNI</MenuItem>
                  <MenuItem value="4">Carnet Extranjería</MenuItem>
                  <MenuItem value="7">Pasaporte</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3} sx={{ width: '8em', minWidth: '8em', mt:-2 }}>
                <TextField fullWidth required label="Nro. Doc. Chofer" name="chofer_numero_doc"
                  value={form.chofer_numero_doc} onChange={handleChange} size="small" />
              </Grid>
              <Grid item xs={12} sm={4} sx={{ width: '20em', minWidth: '20em', mt:-2 }}>
                <TextField fullWidth required label="Nombres Chofer" name="chofer_nombres"
                  value={form.chofer_nombres} onChange={handleChange} size="small" />
              </Grid>
              <Grid item xs={12} sm={3} sx={{ width: '10em', minWidth: '10em', mt:-2 }}>
                <TextField fullWidth required label="Licencia" name="chofer_licencia"
                  value={form.chofer_licencia} onChange={handleChange} size="small" />
              </Grid>
              </>)}

              {mostrarOpcionesEspeciales31 && (
                <>
                  <Box sx={{ flexBasis: '100%', height: 0 }} />
                  <Grid item xs={12} sx={{ mt: -2 }}>
                    <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, bgcolor: '#fff' }}>
                      <Typography variant="subtitle2" color="secondary" sx={{ fontWeight: 700, mb: 1 }}>
                        Opciones Transportista (31)
                      </Typography>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} md={4}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="transbordo_programado"
                                checked={!!form.transbordo_programado}
                                onChange={handleChange}
                              />
                            }
                            label="Transbordo Programado"
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="retorno_vehiculo_vacio"
                                checked={!!form.retorno_vehiculo_vacio}
                                onChange={handleChange}
                              />
                            }
                            label="Retorno Vehículo Vacío"
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="retorno_envases_vacios"
                                checked={!!form.retorno_envases_vacios}
                                onChange={handleChange}
                              />
                            }
                            label="Retorno Vehículo Envases Vacíos"
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Box sx={{ flexBasis: '100%', height: 0 }} />
                  <Grid item xs={12} sm={4} sx={{ width: '11em', minWidth: '11em', mt:-2 }}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Pagador de flete"
                      name="pagador_flete"
                      value={form.pagador_flete}
                      onChange={handleChange}
                    >
                      <MenuItem value="remitente">Remitente</MenuItem>
                      <MenuItem value="subcontratador">SubContratador</MenuItem>
                      <MenuItem value="destinatario">Destinatario</MenuItem>
                      <MenuItem value="otro_tercero">Otro (Tercero)</MenuItem>
                    </TextField>
                  </Grid>

                  {mostrarOtroTercero && (
                    <>
                      <Grid item xs={12} sm={3} sx={{ width: '12em', minWidth: '12em', mt:-2 }}>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          label="Tipo Doc Tercero"
                          name="tercero_tipo_doc"
                          value={form.tercero_tipo_doc}
                          onChange={handleChange}
                        >
                          <MenuItem value="6">RUC</MenuItem>
                          <MenuItem value="1">DNI</MenuItem>
                          <MenuItem value="4">Carnet Extranjería</MenuItem>
                          <MenuItem value="7">Pasaporte</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={3} sx={{ width: '11em', minWidth: '11em', mt:-2 }}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Nro. Doc Tercero"
                          name="tercero_numero_doc"
                          value={form.tercero_numero_doc}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} sx={{ width: '30em', minWidth: '30em', mt:-2 }}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Razón Social Tercero"
                          name="tercero_razon_social"
                          value={form.tercero_razon_social}
                          onChange={handleChange}
                        />
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
          )}
          </Paper>

          {/* Sección: Comprobante relacionado */}
          <Paper variant="outlined" sx={{ p:2, mb:2, borderRadius: 2 }}>
          <Box sx={{ display:'flex', alignItems:'center', cursor:'pointer', mb:1 }}
            onClick={() => setExpandComprobanteRelacionado(v => !v)}>
            <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700 }}>Comprobante Relacionado (Opcional) / Adjuntos y Datos Adicionales</Typography>
            <IconButton size="small">{expandComprobanteRelacionado ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
          {expandComprobanteRelacionado && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={() => {
                  setOpenCompRefDialog(true);
                }}
                startIcon={<Add />}
                sx={{ minWidth: 180, fontWeight: 'bold' }}
              >
                Adicionar referencia
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Ref. Comprobante" name="comprobante_relacionado_ref"
                value={form.comprobante_relacionado_ref} onChange={handleChange} size="small" />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleOpenDatosAdicionales}
                startIcon={<Add />}
                sx={{ minWidth: 180, fontWeight: 'bold' }}
              >
                Datos adicionales
              </Button>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                component="label"
                variant="contained"
                color="info"
                fullWidth
                startIcon={<AttachFile />}
                sx={{ minWidth: 60, fontWeight: 'bold' }}
              >
                Adjuntar
                <input
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => {
                    const files = Array.from(e.target.files || []);
                    setAdjuntos(prev => [...prev, ...files]);
                    setForm(f => ({ ...f, adjuntos: [...(f.adjuntos || []), ...files.map(x => x.name)] }));
                  }}
                />
              </Button>
            </Grid>
            <Grid item xs={12} sx={{ mt: 1 }}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {adjuntos.length === 0 && <Typography variant="body2" color="text.secondary">Sin adjuntos</Typography>}
                {adjuntos.map((a, idx) => (
                  <Chip
                    key={`${a.name || a}-${idx}`}
                    label={a.name || String(a)}
                    onDelete={() => {
                      setAdjuntos(prev => prev.filter((_, i) => i !== idx));
                      setForm(f => ({ ...f, adjuntos: (f.adjuntos || []).filter((_, i) => i !== idx) }));
                    }}
                    size="small"
                    variant="outlined"
                  />
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ minWidth: '53.4em', width: '53.4em' }}>
              <TextField fullWidth label="Observaciones" name="observaciones"
                value={form.observaciones} onChange={handleChange} size="small" />
            </Grid>
          </Grid>
          )}
          </Paper>

          {/* Sección: Ítems / Bienes */}
          <Paper variant="outlined" sx={{ p:2, borderRadius: 2 }}>
          <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:1 }}>
            <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 700 }}>Bienes a Transportar</Typography>
          </Box>
          <TableContainer component={Paper} variant="outlined" sx={{ mb:1 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor:'#2e8ae6' }}>
                  <TableCell>#</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Descripción</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Cantidad</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Unidad</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Almacén</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Observaciones</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }} align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detalles.length === 0 ? (
                  <TableRow><TableCell colSpan={7} align="center">Sin ítems</TableCell></TableRow>
                ) : detalles.map((d, idx) => (
                  <TableRow key={idx} sx={{ backgroundColor: idx % 2 === 0 ? '#f5f5f5' : '#fff' }}>
                    <TableCell>{idx+1}</TableCell>
                    <TableCell>{d.descripcion_producto}</TableCell>
                    <TableCell>{d.cantidad}</TableCell>
                    <TableCell>{d.unidad_medida}</TableCell>
                    <TableCell>{almacenes.find(a => Number(a.id) === Number(d.almacen_id))?.nombre || '-'}</TableCell>
                    <TableCell>{d.observaciones || ''}</TableCell>
                    <TableCell align="center">
                      <IconButton size="small" onClick={() => abrirEditarDetalle(idx)}><Edit fontSize="small" /></IconButton>
                      <IconButton size="small" color="error" onClick={() => eliminarDetalle(idx)}><Delete fontSize="small" /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
            <FormControlLabel
              control={<Checkbox checked={copiarNombreADesc} onChange={e => setCopiarNombreADesc(e.target.checked)} color="secondary" size="small" />}
              label={<Typography variant="caption">Copiar nombre → descripción</Typography>}
            />
          </Box>
          <Grid container spacing={1} alignItems="center" justifyContent="center">
            <Grid item xs={4} sx={{ minWidth: '20em' }}>
              <Autocomplete
                options={productosCatalogo}
                getOptionLabel={option => option?.codigo ? `${option.codigo} - ${option.nombre || option.descripcion || ''}` : (option?.nombre || option?.descripcion || '')}
                value={productosCatalogo.find(p => Number(p.id) === Number(detalleForm.producto_id)) || null}
                inputValue={productoInput}
                onInputChange={(_, v) => setProductoInput(v)}
                onChange={(e, value) => {
                  prepararDetalleDesdeProducto(value ? value.id : '');
                  if (value) setProductoInput(value?.codigo ? `${value.codigo} - ${value.nombre || ''}` : (value?.nombre || value?.descripcion || ''));
                  if (value && almacenes.length > 0 && !detalleForm.almacen_id) {
                    setDetalleForm(f => ({ ...f, almacen_id: almacenes[0].id }));
                  }
                }}
                isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                noOptionsText={
                  productoInput.length >= 2 ? (
                    <Button size="small" onMouseDown={(e) => e.preventDefault()} onClick={() => setOpenNuevoProducto(true)}>+ Registrar "{productoInput}" como nuevo producto</Button>
                  ) : 'Escribe para buscar'
                }
                renderInput={params => (
                  <TextField {...params} label="Producto" size="small" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={4} sx={{ minWidth: '21em' }}>
              <TextField
                label="Descripción de producto"
                size="small"
                value={detalleForm.descripcion_producto}
                onChange={e => setDetalleForm(f => ({ ...f, descripcion_producto: e.target.value }))}
                fullWidth
                onKeyDown={e => { if (e.key === 'F1') { e.preventDefault(); setOpenBuscadorProducto(true); } }}
                InputProps={{
                  endAdornment: (
                    <Tooltip title="Buscar producto (F1)">
                      <IconButton size="small" onClick={() => setOpenBuscadorProducto(true)} edge="end">
                        <Search fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
              <TextField
                label="Cant."
                size="small"
                type="number"
                value={detalleForm.cantidad}
                onChange={e => setDetalleForm(f => ({ ...f, cantidad: e.target.value }))}
                inputProps={{ min: 0.01, step: 0.01 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={2} sx={{ minWidth: '12em' }}>
              <Autocomplete
                options={unidades}
                getOptionLabel={option => option?.nombre ? `${option.nombre} (${option.codigo_sunat || option.codigo || ''})` : ''}
                value={unidades.find(u => Number(u.id) === Number(detalleForm.unidad_medida_id)) || null}
                onChange={(e, value) => setDetalleForm(f => ({
                  ...f,
                  unidad_medida_id: value ? value.id : '',
                  unidad_medida: value ? (value.codigo_sunat || value.codigo || 'NIU') : 'NIU'
                }))}
                isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                renderInput={params => (
                  <TextField {...params} label="U.Medida" size="small" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={3} sx={{ minWidth: '16em' }}>
              <Autocomplete
                options={almacenesPartidaDisponibles}
                getOptionLabel={option => option?.nombre || ''}
                value={almacenesPartidaDisponibles.find(a => Number(a.id) === Number(detalleForm.almacen_id)) || null}
                onChange={(e, value) => setDetalleForm(f => ({ ...f, almacen_id: value ? value.id : '' }))}
                isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                renderInput={params => (
                  <TextField {...params} label="Almacén" size="small" fullWidth
                    onKeyDown={e => { if (e.key === 'F1') { e.preventDefault(); if (detalleForm.producto_id) setOpenStockAlmacen(true); } }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4} sx={{ minWidth: '20em' }}>
              <TextField
                label="Observaciones"
                size="small"
                value={detalleForm.observaciones || ''}
                onChange={e => setDetalleForm(f => ({ ...f, observaciones: e.target.value }))}
                fullWidth
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="success"
                startIcon={detalleIdx === null ? <Add /> : <CheckCircle />}
                onClick={guardarDetalleInline}
                sx={{ backgroundColor: '#e8f5e9', color: '#388e3c', fontWeight: 'bold' }}
              >
                {detalleIdx === null ? '+ Agregar' : 'Actualizar'}
              </Button>
            </Grid>
          </Grid>
            </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)} disabled={saving}>Cancelar</Button>
          <Button variant="contained" onClick={guardar} disabled={saving} startIcon={saving ? <CircularProgress size={16} /> : null}>
            {modoEdicion ? 'Actualizar' : 'Guardar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openCompRefDialog} onClose={() => setOpenCompRefDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 20 }}>
          Seleccionar comprobante de referencia
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 1 }}>
            <TextField
              placeholder="Buscar por serie, número, RUC o razón social..."
              value={searchReferenciaComp}
              onChange={e => setSearchReferenciaComp(e.target.value)}
              size="small"
              sx={{ flex: 1, minWidth: 220 }}
            />
            <TextField
              select
              size="small"
              label="Tipo"
              value={tipoDocReferenciaComp}
              onChange={e => setTipoDocReferenciaComp(e.target.value)}
              sx={{ minWidth: 160 }}
            >
              <MenuItem value="01">Factura</MenuItem>
              <MenuItem value="03">Boleta</MenuItem>
            </TextField>
          </Box>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#2e8ae6' }}>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Tipo</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Serie-Número</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Fecha</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Cliente</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Documento</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 'bold' }} align="center">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loadingReferenciasComp ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center"><CircularProgress size={22} /></TableCell>
                  </TableRow>
                ) : referenciasComp.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">Sin comprobantes para mostrar</TableCell>
                  </TableRow>
                ) : referenciasComp.map(ref => (
                  <TableRow key={ref.id} hover>
                    <TableCell>{ref.tipo_comprobante === '01' ? 'Factura' : 'Boleta'}</TableCell>
                    <TableCell>{ref.serie}-{String(ref.numero).padStart(8, '0')}</TableCell>
                    <TableCell>{ref.fecha_emision ? String(ref.fecha_emision).slice(0, 10) : ''}</TableCell>
                    <TableCell>{ref.razon_social || '-'}</TableCell>
                    <TableCell>{ref.numero_documento || '-'}</TableCell>
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => aplicarComprobanteReferencia({
                          id: ref.id,
                          serie: ref.serie,
                          numero: ref.numero,
                          cliente: ref.razon_social,
                          cliente_ruc: ref.numero_documento,
                          tipo_comprobante: ref.tipo_comprobante
                        })}
                        disabled={loadingImportRef}
                      >
                        Seleccionar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCompRefDialog(false)} disabled={loadingImportRef}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openPdfDialog} onClose={() => setOpenPdfDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold' }}>Descargar PDF de guía</DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            Se usará la plantilla asignada en <strong>Plantillas PDF</strong> para el formato seleccionado.
          </Alert>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5, mb: 2 }}>
            {[
              { codigo: 'A4',  titulo: 'A4',          detalle: 'Formato completo' },
              { codigo: 'A5',  titulo: 'A5',          detalle: 'Formato compacto' },
              { codigo: 'T80', titulo: 'Ticket 80mm', detalle: 'Impresora térmica' }
            ].map((item) => (
              <Paper
                key={item.codigo}
                onClick={() => {
                  setPdfFormatoSeleccionado(item.codigo);
                  localStorage.setItem('guia_pdf_formato_default', item.codigo);
                }}
                sx={{
                  p: 2, cursor: 'pointer', border: '2px solid',
                  borderColor: pdfFormatoSeleccionado === item.codigo ? '#1976d2' : '#d0d7de',
                  backgroundColor: pdfFormatoSeleccionado === item.codigo ? '#e3f2fd' : '#fff'
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' }}>{item.titulo}</Typography>
                <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>{item.detalle}</Typography>
              </Paper>
            ))}
          </Box>
          {guiaPdfTarget && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Guía: T.{guiaPdfTarget.tipo_guia} — {guiaPdfTarget.serie}-{String(guiaPdfTarget.numero || '').padStart(8, '0')}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPdfDialog(false)}>Cancelar</Button>
          <Button variant="contained" onClick={descargarPdfGuia}>
            Descargar {pdfFormatoSeleccionado}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDatosAdicionales} onClose={() => setOpenDatosAdicionales(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold' }}>Datos adicionales</DialogTitle>
        <DialogContent>
          <TextField
            label="Placa"
            value={placaAdicional}
            onChange={e => setPlacaAdicional(e.target.value)}
            fullWidth
            margin="normal"
            placeholder="Ingrese la placa..."
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setForm(f => ({ ...f, dato_adicional_placa: placaAdicional }));
              setOpenDatosAdicionales(false);
            }}
          >
            Guardar
          </Button>
          <Button onClick={() => setOpenDatosAdicionales(false)} color="error" variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── DIALOG: Nuevo Vehículo ──────────────────────────────────────── */}
      <Dialog open={openVehiculo} onClose={() => setOpenVehiculo(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Nuevo Vehículo</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}><TextField fullWidth label="Placa *" size="small" value={vehiculoForm.placa} onChange={e => setVehiculoForm(f=>({...f,placa:e.target.value}))} inputProps={{maxLength:15}} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Marca" size="small" value={vehiculoForm.marca} onChange={e => setVehiculoForm(f=>({...f,marca:e.target.value}))} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Modelo" size="small" value={vehiculoForm.modelo} onChange={e => setVehiculoForm(f=>({...f,modelo:e.target.value}))} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Color" size="small" value={vehiculoForm.color} onChange={e => setVehiculoForm(f=>({...f,color:e.target.value}))} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="N° Certificado Inscripción (SUNARP)" size="small" value={vehiculoForm.nro_certificado_inscripcion} onChange={e => setVehiculoForm(f=>({...f,nro_certificado_inscripcion:e.target.value}))} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenVehiculo(false)}>Cancelar</Button>
          <Button variant="contained" onClick={guardarVehiculo}>Guardar</Button>
        </DialogActions>
      </Dialog>

      {/* ── DIALOG: Nuevo Chofer ────────────────────────────────────────── */}
      <Dialog open={openChofer} onClose={() => { setOpenChofer(false); setChoferDniError(''); setChoferForm({ nombres:'', apellidos:'', tipo_documento:'1', numero_documento:'', licencia:'' }); }} maxWidth="sm" fullWidth>
        <DialogTitle>Nuevo Chofer</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField select fullWidth label="Tipo Doc" size="small" value={choferForm.tipo_documento} onChange={e => setChoferForm(f=>({...f,tipo_documento:e.target.value,numero_documento:'',nombres:'',apellidos:''}))}
              >
                <MenuItem value="1">DNI</MenuItem>
                <MenuItem value="4">Carnet Extranjería</MenuItem>
                <MenuItem value="7">Pasaporte</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={8}>
              <Box sx={{ display:'flex', gap:1, alignItems:'center' }}>
                <TextField fullWidth label="Nro. Documento *" size="small"
                  value={choferForm.numero_documento}
                  onChange={e => setChoferForm(f=>({...f,numero_documento:e.target.value}))}
                  inputProps={{ maxLength: choferForm.tipo_documento === '1' ? 8 : 20 }}
                />
                {choferForm.tipo_documento === '1' && (
                  <Tooltip title="Consultar RENIEC">
                    <span>
                      <IconButton size="small" onClick={handleBuscarDniChofer}
                        disabled={loadingChoferDni || (choferForm.numero_documento || '').length !== 8}>
                        {loadingChoferDni ? <CircularProgress size={18} /> : <Search fontSize="small" />}
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Box>
              {choferDniError && <Typography variant="caption" color="error">{choferDniError}</Typography>}
            </Grid>
            <Grid item xs={6}><TextField fullWidth label="Nombres *" size="small" value={choferForm.nombres} onChange={e => setChoferForm(f=>({...f,nombres:e.target.value}))} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Apellidos *" size="small" value={choferForm.apellidos} onChange={e => setChoferForm(f=>({...f,apellidos:e.target.value}))} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Licencia" size="small" value={choferForm.licencia} onChange={e => setChoferForm(f=>({...f,licencia:e.target.value}))} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenChofer(false); setChoferDniError(''); setChoferForm({ nombres:'', apellidos:'', tipo_documento:'1', numero_documento:'', licencia:'' }); }}>Cancelar</Button>
          <Button variant="contained" onClick={async () => { await guardarChofer(); setChoferDniError(''); setChoferForm({ nombres:'', apellidos:'', tipo_documento:'1', numero_documento:'', licencia:'' }); }}>Guardar</Button>
        </DialogActions>
      </Dialog>
      {/* ── DIALOG: Nuevo Transportista ─────────────────────────────────── */}
      <Dialog open={openTransportista} onClose={() => setOpenTransportista(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Nueva Empresa Transportista</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={4}><TextField fullWidth label="RUC *" size="small" value={transportistaForm.ruc} onChange={e => setTransportistaForm(f=>({...f,ruc:e.target.value}))} inputProps={{maxLength:11}} /></Grid>
            <Grid item xs={8}><TextField fullWidth label="Razón Social *" size="small" value={transportistaForm.razon_social} onChange={e => setTransportistaForm(f=>({...f,razon_social:e.target.value}))} /></Grid>
            <Grid item xs={4}>
              <TextField select fullWidth label="Tipo Transporte" size="small" value={transportistaForm.tipo_transporte} onChange={e => setTransportistaForm(f=>({...f,tipo_transporte:e.target.value}))}>
                <MenuItem value="Publico">Público</MenuItem>
                <MenuItem value="Privado">Privado</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={4}><TextField fullWidth label="N° Registro MTC" size="small" value={transportistaForm.numero_registro_mtc} onChange={e => setTransportistaForm(f=>({...f,numero_registro_mtc:e.target.value}))} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Dirección" size="small" value={transportistaForm.direccion} onChange={e => setTransportistaForm(f=>({...f,direccion:e.target.value}))} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTransportista(false)}>Cancelar</Button>
          <Button variant="contained" onClick={guardarTransportista}>Guardar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openPuntosPartida} onClose={() => setOpenPuntosPartida(false)} maxWidth="md" fullWidth>
        <DialogTitle>Configurar Puntos de Partida</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={3} sx={{ minWidth: '11em', width: '11em' }}>
              <TextField fullWidth label="Nombre *" size="small" value={puntoForm.nombre} onChange={e => setPuntoForm(f => ({ ...f, nombre: e.target.value }))} />
            </Grid>
            <Grid item xs={12} sm={3} sx={{ minWidth: '17em', width: '17em' }}>
              <Autocomplete
                options={ubigeoOptions}
                getOptionLabel={(o) => {
                  if (!o) return '';
                  const codigo = o.codigo || '';
                  const dep = o.departamento || '';
                  const prov = o.provincia || '';
                  const dist = o.distrito || '';
                  return [codigo, dep, prov, dist].filter(Boolean).join(' - ');
                }}
                value={ubigeoOptions.find(u => String(u.codigo) === String(puntoForm.ubigeo)) || (puntoForm.ubigeo ? { codigo: puntoForm.ubigeo } : null)}
                inputValue={ubigeoInputPunto}
                onInputChange={(_, v, reason) => {
                  if (reason === 'input') {
                    setUbigeoInputPunto(v);
                    buscarUbigeoPunto(v);
                    return;
                  }
                  if (reason === 'clear') {
                    setUbigeoInputPunto('');
                    setPuntoForm(f => ({ ...f, ubigeo: '' }));
                  }
                }}
                onChange={(_, v) => {
                  setPuntoForm(f => ({ ...f, ubigeo: v?.codigo || '' }));
                  setUbigeoInputPunto(v ? [v.codigo, v.departamento, v.provincia, v.distrito].filter(Boolean).join(' - ') : '');
                  if (v?.codigo) {
                    setUbigeoOptions(prev => prev.some(x => String(x.codigo) === String(v.codigo)) ? prev : [v, ...prev]);
                  }
                }}
                isOptionEqualToValue={(o, v) => String(o?.codigo || '') === String(v?.codigo || '')}
                filterOptions={(x) => x}
                loading={loadingUbigeoPunto}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Ubigeo *"
                    size="small"
                    placeholder="Buscar por código, departamento, provincia o distrito"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} sx={{ minWidth: '14em', width: '14em' }}>
              <TextField select fullWidth label="Sucursal" size="small" value={puntoForm.sucursal_id} onChange={e => setPuntoForm(f => ({ ...f, sucursal_id: e.target.value }))}>
                {sucursales.map(s => <MenuItem key={s.id} value={s.id}>{s.nombre}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="contained" fullWidth onClick={guardarPunto} sx={{ height: '40px' }} startIcon={puntoForm.id ? <CheckCircle /> : <Add />}>
                {puntoForm.id ? 'Actualizar' : 'Agregar'}
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ minWidth: '26em', width: '26em' }}>
              <TextField fullWidth label="Dirección *" size="small" value={puntoForm.direccion} onChange={e => setPuntoForm(f => ({ ...f, direccion: e.target.value }))} />
            </Grid>
            <Grid item xs={12} sm={12} sx={{ minWidth: '26em', width: '26em' }}>
              <TextField fullWidth label="Descripción" size="small" value={puntoForm.descripcion} onChange={e => setPuntoForm(f => ({ ...f, descripcion: e.target.value }))} />
            </Grid>
          </Grid>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Ubigeo</TableCell>
                  <TableCell>Dirección</TableCell>
                  <TableCell>Sucursal</TableCell>
                  <TableCell align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {almacenes.length === 0 ? (
                  <TableRow><TableCell colSpan={5} align="center">Sin puntos registrados</TableCell></TableRow>
                ) : almacenes.map(a => (
                  <TableRow key={a.id}>
                    <TableCell>{a.nombre}</TableCell>
                    <TableCell>{a.ubigeo}</TableCell>
                    <TableCell>{a.direccion}</TableCell>
                    <TableCell>{sucursales.find(s => Number(s.id) === Number(a.sucursal_id))?.nombre || '-'}</TableCell>
                    <TableCell align="center">
                      <IconButton size="small" onClick={() => editarPunto(a)}><Edit fontSize="small" /></IconButton>
                      <Tooltip title="Eliminación temporalmente deshabilitada">
                        <span>
                          <IconButton size="small" color="error" disabled><Delete fontSize="small" /></IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPuntosPartida(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

    {/* Dialog registro rápido de cliente */}
    <ClienteRapidoDialog
      open={openNuevoCliente}
      onClose={() => setOpenNuevoCliente(false)}
      initialQuery={clienteInput}
      onClienteCreado={async (nuevoCliente) => {
        const res = await axios.get('/api/auxiliares');
        setClientes(res.data);
        handleSelectCliente(nuevoCliente);
        setClienteInput(`${nuevoCliente.numero_documento || ''} - ${nuevoCliente.razon_social || ''}`);
        setOpenNuevoCliente(false);
      }}
    />

    {/* Dialog registro rápido de producto */}
    <ProductoRapidoDialog
      open={openNuevoProducto}
      onClose={() => setOpenNuevoProducto(false)}
      initialNombre={productoInput}
      onProductoCreado={async (nuevoProducto) => {
        const res = await axios.get('/api/productos');
        setProductosCatalogo(res.data);
        prepararDetalleDesdeProducto(nuevoProducto.id);
        setProductoInput(nuevoProducto?.codigo ? `${nuevoProducto.codigo} - ${nuevoProducto.nombre || ''}` : (nuevoProducto?.nombre || ''));
        setOpenNuevoProducto(false);
      }}
    />
    <ProductoBuscadorDialog
      open={openBuscadorProducto}
      onClose={() => setOpenBuscadorProducto(false)}
      onSelect={handleBuscadorSelectGuia}
    />
    <StockAlmacenesDialog
      open={openStockAlmacen}
      onClose={() => setOpenStockAlmacen(false)}
      productoId={detalleForm.producto_id}
      productoNombre={detalleForm.descripcion_producto}
    />

    <WhatsAppDialog
      open={wspDialog.open}
      onClose={() => setWspDialog({ open: false, data: null })}
      docTipo="guia"
      tipoDoc={wspDialog.data?.tipo_guia || '31'}
      docId={wspDialog.data?.id}
      clienteId={wspDialog.data?.destinatario_id || wspDialog.data?.cliente_id}
      serie={wspDialog.data?.serie || ''}
      numero={wspDialog.data?.numero || ''}
      fecha={wspDialog.data?.fecha_emision || ''}
      total={0}
      moneda="PEN"
      clienteNombre={wspDialog.data?.destinatario_razon_social || ''}
    />
    <EmailDialog
      open={emailDialog.open}
      onClose={() => setEmailDialog({ open: false, data: null })}
      docTipo="guia"
      tipoDoc={emailDialog.data?.tipo_guia || '31'}
      docId={emailDialog.data?.id}
      clienteId={emailDialog.data?.destinatario_id || emailDialog.data?.cliente_id}
      serie={emailDialog.data?.serie || ''}
      numero={emailDialog.data?.numero || ''}
      fecha={emailDialog.data?.fecha_emision || ''}
      total={0}
      moneda="PEN"
      clienteNombre={emailDialog.data?.destinatario_razon_social || ''}
    />
    {/* ── Diálogo: Anular guía en el sistema ─────────────────────────────── */}
    <Dialog open={anularDialog.open} onClose={() => setAnularDialog({ open: false, data: null, confirmado: false })} maxWidth="xs" fullWidth>
      <DialogTitle>Anular guía en el sistema</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Este sistema no puede anular la guía en SUNAT automáticamente — eso solo se puede hacer
          desde el portal de SUNAT con Clave SOL. Esta acción solo actualiza el estado dentro
          del sistema (y revierte el movimiento de kardex que generó, si aplica).
        </Alert>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Guía: <b>{anularDialog.data?.serie}-{String(anularDialog.data?.numero).padStart(8, '0')}</b>
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={anularDialog.confirmado}
              onChange={(e) => setAnularDialog(d => ({ ...d, confirmado: e.target.checked }))}
            />
          }
          label="Confirmo que ya anulé esta guía en SUNAT mediante Clave SOL."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setAnularDialog({ open: false, data: null, confirmado: false })}>Cancelar</Button>
        <Button
          variant="contained"
          color="error"
          disabled={!anularDialog.confirmado || anulandoGuiaId === anularDialog.data?.id}
          onClick={confirmarAnularEnSistema}
        >
          {anulandoGuiaId === anularDialog.data?.id ? <CircularProgress size={18} color="inherit" /> : 'Anular en el sistema'}
        </Button>
      </DialogActions>
    </Dialog>

    {/* ── Dialog: gestión de direcciones del cliente ────────────────── */}
    <Dialog open={openDirecciones} onClose={() => { setOpenDirecciones(false); cancelarEditarDireccion(); }} maxWidth="sm" fullWidth>
      <DialogTitle>Direcciones del cliente</DialogTitle>
      <DialogContent>
        {/* Tabla de direcciones existentes */}
        {direccionesCliente.length > 0 && (
          <TableContainer component={Paper} variant="outlined" sx={{ mb: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: 'grey.50' }}>
                  <TableCell><strong>Descripción</strong></TableCell>
                  <TableCell><strong>Dirección</strong></TableCell>
                  <TableCell align="center"><strong>Principal</strong></TableCell>
                  <TableCell align="right" sx={{ width: 80 }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {direccionesCliente.map(d => (
                  <TableRow key={d.id} hover selected={dirForm.id === d.id}>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{d.descripcion}</TableCell>
                    <TableCell>
                      <Typography variant="body2">{d.direccion}</Typography>
                      {d.ubigeo_desc && <Typography variant="caption" color="text.secondary">{d.ubigeo_desc}</Typography>}
                    </TableCell>
                    <TableCell align="center">{d.es_principal ? '★' : ''}</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                      <IconButton size="small" color="primary" onClick={() => abrirEditarDireccion(d)}>
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton size="small" color="error" onClick={() => eliminarDireccionT(d.id)}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {/* Formulario nueva/editar dirección */}
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {dirForm.id ? 'Editar dirección' : 'Nueva dirección'}
        </Typography>
        {dirError && <Alert severity="error" sx={{ mb: 1 }}>{dirError}</Alert>}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <TextField size="small" label="Descripción" value={dirForm.descripcion}
            onChange={e => setDirForm(f => ({ ...f, descripcion: e.target.value }))}
            placeholder="Ej: Almacén Central, Tienda Principal..."
            sx={{ width: '20em' }} />
          <TextField size="small" label="Dirección *" value={dirForm.direccion}
            onChange={e => setDirForm(f => ({ ...f, direccion: e.target.value }))}
            sx={{ width: '29em', maxWidth: '100%' }} />
          <Autocomplete
            sx={{ width: '29em', maxWidth: '100%' }}
            options={ubigeosDirDlg}
            getOptionLabel={opt => `${opt.departamento}, ${opt.provincia}, ${opt.distrito} (${opt.codigo})`}
            value={ubigeoSelDirDlg}
            inputValue={ubigeoInputDirDlg}
            onInputChange={handleUbigeoInputDirDlg}
            onChange={(_, val) => {
              setUbigeoSelDirDlg(val);
              setDirForm(f => ({
                ...f,
                ubigeo: val ? val.codigo : '',
                ubigeo_desc: val ? `${val.departamento}, ${val.provincia}, ${val.distrito}` : ''
              }));
            }}
            isOptionEqualToValue={(opt, val) => opt && val && opt.codigo === val.codigo}
            filterOptions={x => x}
            renderInput={params => (
              <TextField {...params} size="small" fullWidth label="Ubigeo"
                placeholder="Escribe Lima, Callao, código (070101)..." />
            )}
          />
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
            <input type="checkbox" checked={!!dirForm.es_principal}
              onChange={e => setDirForm(f => ({ ...f, es_principal: e.target.checked }))} />
            <Typography variant="body2">Marcar como dirección principal</Typography>
          </label>
        </Box>
      </DialogContent>
      <DialogActions>
        {dirForm.id && (
          <Button onClick={cancelarEditarDireccion} sx={{ mr: 'auto' }}>
            Cancelar edición
          </Button>
        )}
        <Button onClick={() => { setOpenDirecciones(false); cancelarEditarDireccion(); }} startIcon={<Cancel />}>
          Cerrar
        </Button>
        <Button variant="contained" onClick={guardarDireccionT} startIcon={<Add />}>
          {dirForm.id ? 'Actualizar' : 'Agregar dirección'}
        </Button>
      </DialogActions>
    </Dialog>

    </Box>
  );
};

export default GuiaRemisionTransportistaPage;
